import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var CompetitionAnalysis = /*#__PURE__*/function (CompetitionAnalysis) {
  CompetitionAnalysis[CompetitionAnalysis["UNSET"] = 0] = "UNSET";
  CompetitionAnalysis[CompetitionAnalysis["INDUSTRY_DATA"] = 1] = "INDUSTRY_DATA";
  CompetitionAnalysis[CompetitionAnalysis["COMPETITOR_DATA"] = 2] = "COMPETITOR_DATA";
  CompetitionAnalysis[CompetitionAnalysis["DIRECT_COMPETITOR_DATA"] = 3] = "DIRECT_COMPETITOR_DATA";
  return CompetitionAnalysis;
}(CompetitionAnalysis || {});
var GlobalConfigEnabledSection = /*#__PURE__*/function (GlobalConfigEnabledSection) {
  GlobalConfigEnabledSection[GlobalConfigEnabledSection["REVIEWS"] = 0] = "REVIEWS";
  GlobalConfigEnabledSection[GlobalConfigEnabledSection["LISTINGS"] = 1] = "LISTINGS";
  GlobalConfigEnabledSection[GlobalConfigEnabledSection["SOCIAL"] = 2] = "SOCIAL";
  GlobalConfigEnabledSection[GlobalConfigEnabledSection["WEBSITE"] = 3] = "WEBSITE";
  GlobalConfigEnabledSection[GlobalConfigEnabledSection["ADVERTISING"] = 4] = "ADVERTISING";
  GlobalConfigEnabledSection[GlobalConfigEnabledSection["SEO"] = 5] = "SEO";
  GlobalConfigEnabledSection[GlobalConfigEnabledSection["ECOMMERCE"] = 6] = "ECOMMERCE";
  GlobalConfigEnabledSection[GlobalConfigEnabledSection["TECHNOLOGY"] = 7] = "TECHNOLOGY";
  return GlobalConfigEnabledSection;
}(GlobalConfigEnabledSection || {});
var Grade = /*#__PURE__*/function (Grade) {
  Grade[Grade["NO_GRADE"] = 0] = "NO_GRADE";
  Grade[Grade["A"] = 1] = "A";
  Grade[Grade["B"] = 2] = "B";
  Grade[Grade["C"] = 3] = "C";
  Grade[Grade["D"] = 4] = "D";
  Grade[Grade["F"] = 5] = "F";
  return Grade;
}(Grade || {});
var Section = /*#__PURE__*/function (Section) {
  Section[Section["REVIEWS"] = 0] = "REVIEWS";
  Section[Section["LISTINGS"] = 1] = "LISTINGS";
  Section[Section["SOCIAL"] = 2] = "SOCIAL";
  Section[Section["WEBSITE"] = 3] = "WEBSITE";
  Section[Section["ADVERTISING"] = 4] = "ADVERTISING";
  Section[Section["SNAPSHOT"] = 5] = "SNAPSHOT";
  Section[Section["SEO"] = 6] = "SEO";
  Section[Section["ECOMMERCE"] = 7] = "ECOMMERCE";
  Section[Section["TECHNOLOGY"] = 8] = "TECHNOLOGY";
  return Section;
}(Section || {});
var VideoStyle = /*#__PURE__*/function (VideoStyle) {
  VideoStyle[VideoStyle["NO_VIDEOS"] = 0] = "NO_VIDEOS";
  VideoStyle[VideoStyle["NORTH_AMERICAN_LEGACY"] = 1] = "NORTH_AMERICAN_LEGACY";
  VideoStyle[VideoStyle["NORTH_AMERICAN"] = 2] = "NORTH_AMERICAN";
  VideoStyle[VideoStyle["AUSTRALIAN"] = 3] = "AUSTRALIAN";
  VideoStyle[VideoStyle["UNITED_KINGDOM"] = 4] = "UNITED_KINGDOM";
  VideoStyle[VideoStyle["SOUTH_AFRICA"] = 5] = "SOUTH_AFRICA";
  VideoStyle[VideoStyle["FRENCH"] = 6] = "FRENCH";
  return VideoStyle;
}(VideoStyle || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ListingListingStatus = /*#__PURE__*/function (ListingListingStatus) {
  ListingListingStatus[ListingListingStatus["ACCURATE"] = 0] = "ACCURATE";
  ListingListingStatus[ListingListingStatus["INACCURATE"] = 1] = "INACCURATE";
  ListingListingStatus[ListingListingStatus["NOT_FOUND"] = 2] = "NOT_FOUND";
  return ListingListingStatus;
}(ListingListingStatus || {});
var ListingV2ListingStatus = /*#__PURE__*/function (ListingV2ListingStatus) {
  ListingV2ListingStatus[ListingV2ListingStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
  ListingV2ListingStatus[ListingV2ListingStatus["ACCURATE"] = 1] = "ACCURATE";
  ListingV2ListingStatus[ListingV2ListingStatus["INACCURATE"] = 2] = "INACCURATE";
  ListingV2ListingStatus[ListingV2ListingStatus["NOT_FOUND"] = 3] = "NOT_FOUND";
  return ListingV2ListingStatus;
}(ListingV2ListingStatus || {});
var DataProviderAccuracyStatus = /*#__PURE__*/function (DataProviderAccuracyStatus) {
  DataProviderAccuracyStatus[DataProviderAccuracyStatus["ACCURATE"] = 0] = "ACCURATE";
  DataProviderAccuracyStatus[DataProviderAccuracyStatus["NOT_FOUND"] = 1] = "NOT_FOUND";
  DataProviderAccuracyStatus[DataProviderAccuracyStatus["CONTAINS_ERRORS"] = 2] = "CONTAINS_ERRORS";
  return DataProviderAccuracyStatus;
}(DataProviderAccuracyStatus || {});
var DataProviderAccuracyStatusV2 = /*#__PURE__*/function (DataProviderAccuracyStatusV2) {
  DataProviderAccuracyStatusV2[DataProviderAccuracyStatusV2["UNSPECIFIED_V2"] = 0] = "UNSPECIFIED_V2";
  DataProviderAccuracyStatusV2[DataProviderAccuracyStatusV2["ACCURATE_V2"] = 1] = "ACCURATE_V2";
  DataProviderAccuracyStatusV2[DataProviderAccuracyStatusV2["NOT_FOUND_V2"] = 2] = "NOT_FOUND_V2";
  DataProviderAccuracyStatusV2[DataProviderAccuracyStatusV2["CONTAINS_ERRORS_V2"] = 3] = "CONTAINS_ERRORS_V2";
  return DataProviderAccuracyStatusV2;
}(DataProviderAccuracyStatusV2 || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var GMBClaimStatus = /*#__PURE__*/function (GMBClaimStatus) {
  GMBClaimStatus[GMBClaimStatus["GMB_CLAIM_STATUS_INVALID"] = 0] = "GMB_CLAIM_STATUS_INVALID";
  GMBClaimStatus[GMBClaimStatus["GMB_CLAIM_STATUS_UNKNOWN"] = 1] = "GMB_CLAIM_STATUS_UNKNOWN";
  GMBClaimStatus[GMBClaimStatus["GMB_CLAIM_STATUS_CLAIMED"] = 2] = "GMB_CLAIM_STATUS_CLAIMED";
  GMBClaimStatus[GMBClaimStatus["GMB_CLAIM_STATUS_UNCLAIMED"] = 3] = "GMB_CLAIM_STATUS_UNCLAIMED";
  return GMBClaimStatus;
}(GMBClaimStatus || {});
var Status = /*#__PURE__*/function (Status) {
  Status[Status["STATUS_UNDEFINED"] = 0] = "STATUS_UNDEFINED";
  Status[Status["STATUS_DOES_NOT_EXIST"] = 1] = "STATUS_DOES_NOT_EXIST";
  Status[Status["STATUS_IN_PROGRESS"] = 2] = "STATUS_IN_PROGRESS";
  Status[Status["STATUS_FINISHED"] = 3] = "STATUS_FINISHED";
  return Status;
}(Status || {});
var Vicinity = /*#__PURE__*/function (Vicinity) {
  Vicinity[Vicinity["VICINITY_UNDEFINED"] = 0] = "VICINITY_UNDEFINED";
  Vicinity[Vicinity["VICINITY_CITY"] = 1] = "VICINITY_CITY";
  Vicinity[Vicinity["VICINITY_NEARME"] = 2] = "VICINITY_NEARME";
  Vicinity[Vicinity["VICINITY_NEARME_NORTH"] = 3] = "VICINITY_NEARME_NORTH";
  Vicinity[Vicinity["VICINITY_NEARME_NORTHEAST"] = 4] = "VICINITY_NEARME_NORTHEAST";
  Vicinity[Vicinity["VICINITY_NEARME_EAST"] = 5] = "VICINITY_NEARME_EAST";
  Vicinity[Vicinity["VICINITY_NEARME_SOUTHEAST"] = 6] = "VICINITY_NEARME_SOUTHEAST";
  Vicinity[Vicinity["VICINITY_NEARME_SOUTH"] = 7] = "VICINITY_NEARME_SOUTH";
  Vicinity[Vicinity["VICINITY_NEARME_SOUTHWEST"] = 8] = "VICINITY_NEARME_SOUTHWEST";
  Vicinity[Vicinity["VICINITY_NEARME_WEST"] = 9] = "VICINITY_NEARME_WEST";
  Vicinity[Vicinity["VICINITY_NEARME_NORTHWEST"] = 10] = "VICINITY_NEARME_NORTHWEST";
  return Vicinity;
}(Vicinity || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var InstagramDataInstagramDataStatus = /*#__PURE__*/function (InstagramDataInstagramDataStatus) {
  InstagramDataInstagramDataStatus[InstagramDataInstagramDataStatus["INSTAGRAM_DATA_INSTAGRAM_DATA_STATUS_IN_PROGRESS"] = 0] = "INSTAGRAM_DATA_INSTAGRAM_DATA_STATUS_IN_PROGRESS";
  InstagramDataInstagramDataStatus[InstagramDataInstagramDataStatus["INSTAGRAM_DATA_INSTAGRAM_DATA_STATUS_SUCCESS"] = 1] = "INSTAGRAM_DATA_INSTAGRAM_DATA_STATUS_SUCCESS";
  InstagramDataInstagramDataStatus[InstagramDataInstagramDataStatus["INSTAGRAM_DATA_INSTAGRAM_DATA_STATUS_INVALID_USER_ID"] = 2] = "INSTAGRAM_DATA_INSTAGRAM_DATA_STATUS_INVALID_USER_ID";
  InstagramDataInstagramDataStatus[InstagramDataInstagramDataStatus["INSTAGRAM_DATA_INSTAGRAM_DATA_STATUS_UNKNOWN_ERROR"] = 3] = "INSTAGRAM_DATA_INSTAGRAM_DATA_STATUS_UNKNOWN_ERROR";
  InstagramDataInstagramDataStatus[InstagramDataInstagramDataStatus["INSTAGRAM_DATA_INSTAGRAM_DATA_STATUS_REEL_DETECTED"] = 4] = "INSTAGRAM_DATA_INSTAGRAM_DATA_STATUS_REEL_DETECTED";
  return InstagramDataInstagramDataStatus;
}(InstagramDataInstagramDataStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var SSLSummaryStatus = /*#__PURE__*/function (SSLSummaryStatus) {
  SSLSummaryStatus[SSLSummaryStatus["SSL_SUMMARY_STATUS_UNDETERMINED"] = 0] = "SSL_SUMMARY_STATUS_UNDETERMINED";
  SSLSummaryStatus[SSLSummaryStatus["SSL_SUMMARY_STATUS_INVALID"] = 1] = "SSL_SUMMARY_STATUS_INVALID";
  SSLSummaryStatus[SSLSummaryStatus["SSL_SUMMARY_STATUS_VALID"] = 2] = "SSL_SUMMARY_STATUS_VALID";
  return SSLSummaryStatus;
}(SSLSummaryStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Role = /*#__PURE__*/function (Role) {
  Role[Role["ROLE_UNSET"] = 0] = "ROLE_UNSET";
  Role[Role["ROLE_SYSTEM"] = 1] = "ROLE_SYSTEM";
  Role[Role["ROLE_USER"] = 2] = "ROLE_USER";
  Role[Role["ROLE_ASSISTANT"] = 3] = "ROLE_ASSISTANT";
  return Role;
}(Role || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AppDomain = /*#__PURE__*/function (AppDomain) {
  AppDomain[AppDomain["APP_DOMAIN_INVALID"] = 0] = "APP_DOMAIN_INVALID";
  AppDomain[AppDomain["APP_DOMAIN_VBC"] = 1] = "APP_DOMAIN_VBC";
  AppDomain[AppDomain["APP_DOMAIN_MS"] = 2] = "APP_DOMAIN_MS";
  AppDomain[AppDomain["APP_DOMAIN_SM"] = 3] = "APP_DOMAIN_SM";
  AppDomain[AppDomain["APP_DOMAIN_ST"] = 4] = "APP_DOMAIN_ST";
  AppDomain[AppDomain["APP_DOMAIN_RM"] = 5] = "APP_DOMAIN_RM";
  return AppDomain;
}(AppDomain || {});
var CannotProvisionReason = /*#__PURE__*/function (CannotProvisionReason) {
  CannotProvisionReason[CannotProvisionReason["UNKNOWN"] = 0] = "UNKNOWN";
  CannotProvisionReason[CannotProvisionReason["AUTHENTICATION_FAILED"] = 1] = "AUTHENTICATION_FAILED";
  CannotProvisionReason[CannotProvisionReason["ACTIVE_SNAPSHOT_ALREADY_EXISTS"] = 2] = "ACTIVE_SNAPSHOT_ALREADY_EXISTS";
  CannotProvisionReason[CannotProvisionReason["PARTNER_CANNOT_CREATE_SNAPSHOT"] = 3] = "PARTNER_CANNOT_CREATE_SNAPSHOT";
  CannotProvisionReason[CannotProvisionReason["SALESPERSON_SNAPSHOT_LIMIT_REACHED"] = 4] = "SALESPERSON_SNAPSHOT_LIMIT_REACHED";
  return CannotProvisionReason;
}(CannotProvisionReason || {});
// *********************************

function enumStringToValue$k(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class SalesPerson {
  static fromProto(proto) {
    let m = new SalesPerson();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesPersonId !== 'undefined') {
      toReturn['salesPersonId'] = this.salesPersonId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumbers !== 'undefined') {
      toReturn['phoneNumbers'] = this.phoneNumbers;
    }
    if (typeof this.photoUrl !== 'undefined') {
      toReturn['photoUrl'] = this.photoUrl;
    }
    if (typeof this.jobTitle !== 'undefined') {
      toReturn['jobTitle'] = this.jobTitle;
    }
    if (typeof this.coverPageTitle !== 'undefined') {
      toReturn['coverPageTitle'] = this.coverPageTitle;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    return toReturn;
  }
}
function enumStringToValue$j(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Competitor {
  static fromProto(proto) {
    let m = new Competitor();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    return toReturn;
  }
}
class Contact {
  static fromProto(proto) {
    let m = new Contact();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.fullName !== 'undefined') {
      toReturn['fullName'] = this.fullName;
    }
    return toReturn;
  }
}
class Email {
  static fromProto(proto) {
    let m = new Email();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.body !== 'undefined') {
      toReturn['body'] = this.body;
    }
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    if (typeof this.greeting !== 'undefined') {
      toReturn['greeting'] = this.greeting;
    }
    if (typeof this.closing !== 'undefined') {
      toReturn['closing'] = this.closing;
    }
    if (typeof this.buttonText !== 'undefined') {
      toReturn['buttonText'] = this.buttonText;
    }
    return toReturn;
  }
}
class GlobalConfig {
  static fromProto(proto) {
    let m = new GlobalConfig();
    m = Object.assign(m, proto);
    if (proto.videoStyle) {
      m.videoStyle = enumStringToValue$j(VideoStyle, proto.videoStyle);
    }
    if (proto.enabledSections) {
      m.enabledSections = proto.enabledSections.map(v => enumStringToValue$j(GlobalConfigEnabledSection, v));
    }
    if (proto.competitors) {
      m.competitors = proto.competitors.map(Competitor.fromProto);
    }
    if (proto.competitionAnalysis) {
      m.competitionAnalysis = enumStringToValue$j(CompetitionAnalysis, proto.competitionAnalysis);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hideGrades !== 'undefined') {
      toReturn['hideGrades'] = this.hideGrades;
    }
    if (typeof this.videoStyle !== 'undefined') {
      toReturn['videoStyle'] = this.videoStyle;
    }
    if (typeof this.hideImages !== 'undefined') {
      toReturn['hideImages'] = this.hideImages;
    }
    if (typeof this.enabledSections !== 'undefined') {
      toReturn['enabledSections'] = this.enabledSections;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.competitors !== 'undefined' && this.competitors !== null) {
      toReturn['competitors'] = 'toApiJson' in this.competitors ? this.competitors.toApiJson() : this.competitors;
    }
    if (typeof this.hideSubsectionGrades !== 'undefined') {
      toReturn['hideSubsectionGrades'] = this.hideSubsectionGrades;
    }
    if (typeof this.hideScheduleMeetingOption !== 'undefined') {
      toReturn['hideScheduleMeetingOption'] = this.hideScheduleMeetingOption;
    }
    if (typeof this.competitionAnalysis !== 'undefined') {
      toReturn['competitionAnalysis'] = this.competitionAnalysis;
    }
    if (typeof this.customizedFooterCtaLabel !== 'undefined') {
      toReturn['customizedFooterCtaLabel'] = this.customizedFooterCtaLabel;
    }
    if (typeof this.customizedFooterCtaTargetUrl !== 'undefined') {
      toReturn['customizedFooterCtaTargetUrl'] = this.customizedFooterCtaTargetUrl;
    }
    if (typeof this.customizedFooterCtaTargetProduct !== 'undefined') {
      toReturn['customizedFooterCtaTargetProduct'] = this.customizedFooterCtaTargetProduct;
    }
    return toReturn;
  }
}
class IndustryPercentiles {
  static fromProto(proto) {
    let m = new IndustryPercentiles();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fortieth !== 'undefined') {
      toReturn['fortieth'] = this.fortieth;
    }
    if (typeof this.fiftieth !== 'undefined') {
      toReturn['fiftieth'] = this.fiftieth;
    }
    if (typeof this.fiftyFifth !== 'undefined') {
      toReturn['fiftyFifth'] = this.fiftyFifth;
    }
    if (typeof this.seventyFifth !== 'undefined') {
      toReturn['seventyFifth'] = this.seventyFifth;
    }
    if (typeof this.ninetieth !== 'undefined') {
      toReturn['ninetieth'] = this.ninetieth;
    }
    if (typeof this.ninetyFifth !== 'undefined') {
      toReturn['ninetyFifth'] = this.ninetyFifth;
    }
    return toReturn;
  }
}
class InferredFields {
  static fromProto(proto) {
    let m = new InferredFields();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    return toReturn;
  }
}
class LanguageConfig {
  static fromProto(proto) {
    let m = new LanguageConfig();
    m = Object.assign(m, proto);
    if (proto.videoStyle) {
      m.videoStyle = enumStringToValue$j(VideoStyle, proto.videoStyle);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.videoStyle !== 'undefined') {
      toReturn['videoStyle'] = this.videoStyle;
    }
    return toReturn;
  }
}
class SectionContent {
  static fromProto(proto) {
    let m = new SectionContent();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messageId !== 'undefined') {
      toReturn['messageId'] = this.messageId;
    }
    if (typeof this.videoId !== 'undefined') {
      toReturn['videoId'] = this.videoId;
    }
    if (typeof this.footerMessageId !== 'undefined') {
      toReturn['footerMessageId'] = this.footerMessageId;
    }
    return toReturn;
  }
}
class Snapshot {
  static fromProto(proto) {
    let m = new Snapshot();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = GlobalConfig.fromProto(proto.config);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.expired) {
      m.expired = new Date(proto.expired);
    }
    if (proto.data) {
      m.data = SnapshotData.fromProto(proto.data);
    }
    if (proto.salesPerson) {
      m.salesPerson = SalesPerson.fromProto(proto.salesPerson);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.expired !== 'undefined' && this.expired !== null) {
      toReturn['expired'] = 'toApiJson' in this.expired ? this.expired.toApiJson() : this.expired;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.salesPerson !== 'undefined' && this.salesPerson !== null) {
      toReturn['salesPerson'] = 'toApiJson' in this.salesPerson ? this.salesPerson.toApiJson() : this.salesPerson;
    }
    if (typeof this.createdBy !== 'undefined') {
      toReturn['createdBy'] = this.createdBy;
    }
    if (typeof this.isPartnerConfig !== 'undefined') {
      toReturn['isPartnerConfig'] = this.isPartnerConfig;
    }
    return toReturn;
  }
}
class SnapshotData {
  static fromProto(proto) {
    let m = new SnapshotData();
    m = Object.assign(m, proto);
    if (proto.inferredFields) {
      m.inferredFields = InferredFields.fromProto(proto.inferredFields);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.phoneNumbers !== 'undefined') {
      toReturn['phoneNumbers'] = this.phoneNumbers;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.taxonomyId !== 'undefined') {
      toReturn['taxonomyId'] = this.taxonomyId;
    }
    if (typeof this.imageUrls !== 'undefined') {
      toReturn['imageUrls'] = this.imageUrls;
    }
    if (typeof this.taxonomyName !== 'undefined') {
      toReturn['taxonomyName'] = this.taxonomyName;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.facebookUrl !== 'undefined') {
      toReturn['facebookUrl'] = this.facebookUrl;
    }
    if (typeof this.twitterUrl !== 'undefined') {
      toReturn['twitterUrl'] = this.twitterUrl;
    }
    if (typeof this.instagramUrl !== 'undefined') {
      toReturn['instagramUrl'] = this.instagramUrl;
    }
    if (typeof this.serviceAreaBusiness !== 'undefined') {
      toReturn['serviceAreaBusiness'] = this.serviceAreaBusiness;
    }
    if (typeof this.inferredFields !== 'undefined' && this.inferredFields !== null) {
      toReturn['inferredFields'] = 'toApiJson' in this.inferredFields ? this.inferredFields.toApiJson() : this.inferredFields;
    }
    if (typeof this.vcategoryId !== 'undefined') {
      toReturn['vcategoryId'] = this.vcategoryId;
    }
    return toReturn;
  }
}
function enumStringToValue$i(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AdvertisingConfig {
  static fromProto(proto) {
    let m = new AdvertisingConfig();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hideContent !== 'undefined') {
      toReturn['hideContent'] = this.hideContent;
    }
    if (typeof this.customizedMessage !== 'undefined') {
      toReturn['customizedMessage'] = this.customizedMessage;
    }
    if (typeof this.hideSemSection !== 'undefined') {
      toReturn['hideSemSection'] = this.hideSemSection;
    }
    if (typeof this.hideSemPayPerClick !== 'undefined') {
      toReturn['hideSemPayPerClick'] = this.hideSemPayPerClick;
    }
    if (typeof this.hideSemRetargeting !== 'undefined') {
      toReturn['hideSemRetargeting'] = this.hideSemRetargeting;
    }
    if (typeof this.hideSemContent !== 'undefined') {
      toReturn['hideSemContent'] = this.hideSemContent;
    }
    if (typeof this.customizedSemMessage !== 'undefined') {
      toReturn['customizedSemMessage'] = this.customizedSemMessage;
    }
    if (typeof this.hideAdwordsSection !== 'undefined') {
      toReturn['hideAdwordsSection'] = this.hideAdwordsSection;
    }
    if (typeof this.hideFooter !== 'undefined') {
      toReturn['hideFooter'] = this.hideFooter;
    }
    if (typeof this.customizedFooterMessage !== 'undefined') {
      toReturn['customizedFooterMessage'] = this.customizedFooterMessage;
    }
    if (typeof this.customizedFooterCtaLabel !== 'undefined') {
      toReturn['customizedFooterCtaLabel'] = this.customizedFooterCtaLabel;
    }
    if (typeof this.customizedFooterCtaTargetUrl !== 'undefined') {
      toReturn['customizedFooterCtaTargetUrl'] = this.customizedFooterCtaTargetUrl;
    }
    if (typeof this.customizedFooterCtaTargetProduct !== 'undefined') {
      toReturn['customizedFooterCtaTargetProduct'] = this.customizedFooterCtaTargetProduct;
    }
    return toReturn;
  }
}
class AdvertisingData {
  static fromProto(proto) {
    let m = new AdvertisingData();
    m = Object.assign(m, proto);
    if (proto.adwordsData) {
      m.adwordsData = AdwordsData.fromProto(proto.adwordsData);
    }
    if (proto.payPerClickData) {
      m.payPerClickData = PayPerClickData.fromProto(proto.payPerClickData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.adwordsData !== 'undefined' && this.adwordsData !== null) {
      toReturn['adwordsData'] = 'toApiJson' in this.adwordsData ? this.adwordsData.toApiJson() : this.adwordsData;
    }
    if (typeof this.payPerClickData !== 'undefined' && this.payPerClickData !== null) {
      toReturn['payPerClickData'] = 'toApiJson' in this.payPerClickData ? this.payPerClickData.toApiJson() : this.payPerClickData;
    }
    if (typeof this.isRetargeting !== 'undefined') {
      toReturn['isRetargeting'] = this.isRetargeting;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    return toReturn;
  }
}
class AdvertisingSection {
  static fromProto(proto) {
    let m = new AdvertisingSection();
    m = Object.assign(m, proto);
    if (proto.grade) {
      m.grade = enumStringToValue$i(Grade, proto.grade);
    }
    if (proto.content) {
      m.content = SectionContent.fromProto(proto.content);
    }
    if (proto.data) {
      m.data = AdvertisingData.fromProto(proto.data);
    }
    if (proto.config) {
      m.config = AdvertisingConfig.fromProto(proto.config);
    }
    if (proto.semContent) {
      m.semContent = SectionContent.fromProto(proto.semContent);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.grade !== 'undefined') {
      toReturn['grade'] = this.grade;
    }
    if (typeof this.content !== 'undefined' && this.content !== null) {
      toReturn['content'] = 'toApiJson' in this.content ? this.content.toApiJson() : this.content;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    if (typeof this.semContent !== 'undefined' && this.semContent !== null) {
      toReturn['semContent'] = 'toApiJson' in this.semContent ? this.semContent.toApiJson() : this.semContent;
    }
    return toReturn;
  }
}
class AdwordsData {
  static fromProto(proto) {
    let m = new AdwordsData();
    m = Object.assign(m, proto);
    if (proto.impressions) {
      m.impressions = proto.impressions.map(Impressions.fromProto);
    }
    if (proto.clicks) {
      m.clicks = proto.clicks.map(Clicks.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.impressions !== 'undefined' && this.impressions !== null) {
      toReturn['impressions'] = 'toApiJson' in this.impressions ? this.impressions.toApiJson() : this.impressions;
    }
    if (typeof this.clicks !== 'undefined' && this.clicks !== null) {
      toReturn['clicks'] = 'toApiJson' in this.clicks ? this.clicks.toApiJson() : this.clicks;
    }
    if (typeof this.stillWorking !== 'undefined') {
      toReturn['stillWorking'] = this.stillWorking;
    }
    return toReturn;
  }
}
class Clicks {
  static fromProto(proto) {
    let m = new Clicks();
    m = Object.assign(m, proto);
    if (proto.clicksPerMonth) {
      m.clicksPerMonth = FloatRange.fromProto(proto.clicksPerMonth);
    }
    if (proto.averageCostPerClick) {
      m.averageCostPerClick = IntRange.fromProto(proto.averageCostPerClick);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keyword !== 'undefined') {
      toReturn['keyword'] = this.keyword;
    }
    if (typeof this.clicksPerMonth !== 'undefined' && this.clicksPerMonth !== null) {
      toReturn['clicksPerMonth'] = 'toApiJson' in this.clicksPerMonth ? this.clicksPerMonth.toApiJson() : this.clicksPerMonth;
    }
    if (typeof this.averageCostPerClick !== 'undefined' && this.averageCostPerClick !== null) {
      toReturn['averageCostPerClick'] = 'toApiJson' in this.averageCostPerClick ? this.averageCostPerClick.toApiJson() : this.averageCostPerClick;
    }
    return toReturn;
  }
}
class DomainMetrics {
  static fromProto(proto) {
    let m = new DomainMetrics();
    m = Object.assign(m, proto);
    if (proto.averageAdPosition) {
      m.averageAdPosition = parseInt(proto.averageAdPosition, 10);
    }
    if (proto.numberOfAdvertisers) {
      m.numberOfAdvertisers = parseInt(proto.numberOfAdvertisers, 10);
    }
    if (proto.numberOfPaidKeywords) {
      m.numberOfPaidKeywords = parseInt(proto.numberOfPaidKeywords, 10);
    }
    if (proto.paidClicksPerMonth) {
      m.paidClicksPerMonth = parseInt(proto.paidClicksPerMonth, 10);
    }
    if (proto.dailyAdwordsBudget) {
      m.dailyAdwordsBudget = parseInt(proto.dailyAdwordsBudget, 10);
    }
    if (proto.monthlyAdwordsBudget) {
      m.monthlyAdwordsBudget = parseInt(proto.monthlyAdwordsBudget, 10);
    }
    if (proto.paidDomainRanking) {
      m.paidDomainRanking = parseInt(proto.paidDomainRanking, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domainName !== 'undefined') {
      toReturn['domainName'] = this.domainName;
    }
    if (typeof this.averageAdPosition !== 'undefined') {
      toReturn['averageAdPosition'] = this.averageAdPosition;
    }
    if (typeof this.numberOfAdvertisers !== 'undefined') {
      toReturn['numberOfAdvertisers'] = this.numberOfAdvertisers;
    }
    if (typeof this.numberOfPaidKeywords !== 'undefined') {
      toReturn['numberOfPaidKeywords'] = this.numberOfPaidKeywords;
    }
    if (typeof this.paidClicksPerMonth !== 'undefined') {
      toReturn['paidClicksPerMonth'] = this.paidClicksPerMonth;
    }
    if (typeof this.dailyAdwordsBudget !== 'undefined') {
      toReturn['dailyAdwordsBudget'] = this.dailyAdwordsBudget;
    }
    if (typeof this.monthlyAdwordsBudget !== 'undefined') {
      toReturn['monthlyAdwordsBudget'] = this.monthlyAdwordsBudget;
    }
    if (typeof this.paidDomainRanking !== 'undefined') {
      toReturn['paidDomainRanking'] = this.paidDomainRanking;
    }
    if (typeof this.overlap !== 'undefined') {
      toReturn['overlap'] = this.overlap;
    }
    return toReturn;
  }
}
class FloatRange {
  static fromProto(proto) {
    let m = new FloatRange();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.minimum !== 'undefined') {
      toReturn['minimum'] = this.minimum;
    }
    if (typeof this.maximum !== 'undefined') {
      toReturn['maximum'] = this.maximum;
    }
    return toReturn;
  }
}
class Impressions {
  static fromProto(proto) {
    let m = new Impressions();
    m = Object.assign(m, proto);
    if (proto.impressionsPerMonth) {
      m.impressionsPerMonth = FloatRange.fromProto(proto.impressionsPerMonth);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keyword !== 'undefined') {
      toReturn['keyword'] = this.keyword;
    }
    if (typeof this.impressionsPerMonth !== 'undefined' && this.impressionsPerMonth !== null) {
      toReturn['impressionsPerMonth'] = 'toApiJson' in this.impressionsPerMonth ? this.impressionsPerMonth.toApiJson() : this.impressionsPerMonth;
    }
    return toReturn;
  }
}
class IntRange {
  static fromProto(proto) {
    let m = new IntRange();
    m = Object.assign(m, proto);
    if (proto.minimum) {
      m.minimum = parseInt(proto.minimum, 10);
    }
    if (proto.maximum) {
      m.maximum = parseInt(proto.maximum, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.minimum !== 'undefined') {
      toReturn['minimum'] = this.minimum;
    }
    if (typeof this.maximum !== 'undefined') {
      toReturn['maximum'] = this.maximum;
    }
    return toReturn;
  }
}
class PayPerClickData {
  static fromProto(proto) {
    let m = new PayPerClickData();
    m = Object.assign(m, proto);
    if (proto.business) {
      m.business = DomainMetrics.fromProto(proto.business);
    }
    if (proto.competitors) {
      m.competitors = proto.competitors.map(DomainMetrics.fromProto);
    }
    if (proto.grade) {
      m.grade = enumStringToValue$i(Grade, proto.grade);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.business !== 'undefined' && this.business !== null) {
      toReturn['business'] = 'toApiJson' in this.business ? this.business.toApiJson() : this.business;
    }
    if (typeof this.competitors !== 'undefined' && this.competitors !== null) {
      toReturn['competitors'] = 'toApiJson' in this.competitors ? this.competitors.toApiJson() : this.competitors;
    }
    if (typeof this.grade !== 'undefined') {
      toReturn['grade'] = this.grade;
    }
    return toReturn;
  }
}
function enumStringToValue$h(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Configuration {
  static fromProto(proto) {
    let m = new Configuration();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.showPpc !== 'undefined') {
      toReturn['showPpc'] = this.showPpc;
    }
    if (typeof this.showRemarketing !== 'undefined') {
      toReturn['showRemarketing'] = this.showRemarketing;
    }
    if (typeof this.useCustomSnapshotHeader !== 'undefined') {
      toReturn['useCustomSnapshotHeader'] = this.useCustomSnapshotHeader;
    }
    if (typeof this.customSnapshotHeader !== 'undefined') {
      toReturn['customSnapshotHeader'] = this.customSnapshotHeader;
    }
    if (typeof this.useCustomSnapshotFooter !== 'undefined') {
      toReturn['useCustomSnapshotFooter'] = this.useCustomSnapshotFooter;
    }
    if (typeof this.customSnapshotFooter !== 'undefined') {
      toReturn['customSnapshotFooter'] = this.customSnapshotFooter;
    }
    if (typeof this.useCustomSnapshotPopupMessage !== 'undefined') {
      toReturn['useCustomSnapshotPopupMessage'] = this.useCustomSnapshotPopupMessage;
    }
    if (typeof this.customSnapshotPopupMessage !== 'undefined') {
      toReturn['customSnapshotPopupMessage'] = this.customSnapshotPopupMessage;
    }
    if (typeof this.allowClaimUser !== 'undefined') {
      toReturn['allowClaimUser'] = this.allowClaimUser;
    }
    return toReturn;
  }
}
function enumStringToValue$g(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Current {
  static fromProto(proto) {
    let m = new Current();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.expired) {
      m.expired = new Date(proto.expired);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.expired !== 'undefined' && this.expired !== null) {
      toReturn['expired'] = 'toApiJson' in this.expired ? this.expired.toApiJson() : this.expired;
    }
    if (typeof this.path !== 'undefined') {
      toReturn['path'] = this.path;
    }
    return toReturn;
  }
}
function enumStringToValue$f(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$e(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AvailableListingSource {
  static fromProto(proto) {
    let m = new AvailableListingSource();
    m = Object.assign(m, proto);
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.sourceName !== 'undefined') {
      toReturn['sourceName'] = this.sourceName;
    }
    if (typeof this.sourceIconUrl !== 'undefined') {
      toReturn['sourceIconUrl'] = this.sourceIconUrl;
    }
    if (typeof this.ignored !== 'undefined') {
      toReturn['ignored'] = this.ignored;
    }
    return toReturn;
  }
}
class ListingPresenceCompetitor {
  static fromProto(proto) {
    let m = new ListingPresenceCompetitor();
    m = Object.assign(m, proto);
    if (proto.foundCount) {
      m.foundCount = parseInt(proto.foundCount, 10);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.foundCount !== 'undefined') {
      toReturn['foundCount'] = this.foundCount;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
class ListingAccuracyCompetitor {
  static fromProto(proto) {
    let m = new ListingAccuracyCompetitor();
    m = Object.assign(m, proto);
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.accurateListings !== 'undefined') {
      toReturn['accurateListings'] = this.accurateListings;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
class DataProviderAccuracy {
  static fromProto(proto) {
    let m = new DataProviderAccuracy();
    m = Object.assign(m, proto);
    if (proto.neustarAccurate) {
      m.neustarAccurate = enumStringToValue$e(DataProviderAccuracyStatus, proto.neustarAccurate);
    }
    if (proto.factualAccurate) {
      m.factualAccurate = enumStringToValue$e(DataProviderAccuracyStatus, proto.factualAccurate);
    }
    if (proto.acxiomAccurate) {
      m.acxiomAccurate = enumStringToValue$e(DataProviderAccuracyStatus, proto.acxiomAccurate);
    }
    if (proto.infogroupAccurate) {
      m.infogroupAccurate = enumStringToValue$e(DataProviderAccuracyStatus, proto.infogroupAccurate);
    }
    if (proto.neustarStatus) {
      m.neustarStatus = enumStringToValue$e(DataProviderAccuracyStatusV2, proto.neustarStatus);
    }
    if (proto.factualStatus) {
      m.factualStatus = enumStringToValue$e(DataProviderAccuracyStatusV2, proto.factualStatus);
    }
    if (proto.infogroupStatus) {
      m.infogroupStatus = enumStringToValue$e(DataProviderAccuracyStatusV2, proto.infogroupStatus);
    }
    if (proto.foursquareStatus) {
      m.foursquareStatus = enumStringToValue$e(DataProviderAccuracyStatusV2, proto.foursquareStatus);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.neustarAccurate !== 'undefined') {
      toReturn['neustarAccurate'] = this.neustarAccurate;
    }
    if (typeof this.factualAccurate !== 'undefined') {
      toReturn['factualAccurate'] = this.factualAccurate;
    }
    if (typeof this.acxiomAccurate !== 'undefined') {
      toReturn['acxiomAccurate'] = this.acxiomAccurate;
    }
    if (typeof this.infogroupAccurate !== 'undefined') {
      toReturn['infogroupAccurate'] = this.infogroupAccurate;
    }
    if (typeof this.neustarStatus !== 'undefined') {
      toReturn['neustarStatus'] = this.neustarStatus;
    }
    if (typeof this.factualStatus !== 'undefined') {
      toReturn['factualStatus'] = this.factualStatus;
    }
    if (typeof this.infogroupStatus !== 'undefined') {
      toReturn['infogroupStatus'] = this.infogroupStatus;
    }
    if (typeof this.foursquareStatus !== 'undefined') {
      toReturn['foursquareStatus'] = this.foursquareStatus;
    }
    return toReturn;
  }
}
class InaccurateData {
  static fromProto(proto) {
    let m = new InaccurateData();
    m = Object.assign(m, proto);
    if (proto.inaccurateCount) {
      m.inaccurateCount = parseInt(proto.inaccurateCount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.inaccurateCount !== 'undefined') {
      toReturn['inaccurateCount'] = this.inaccurateCount;
    }
    if (typeof this.exampleData !== 'undefined') {
      toReturn['exampleData'] = this.exampleData;
    }
    if (typeof this.sourceName !== 'undefined') {
      toReturn['sourceName'] = this.sourceName;
    }
    if (typeof this.exampleListingUrl !== 'undefined') {
      toReturn['exampleListingUrl'] = this.exampleListingUrl;
    }
    return toReturn;
  }
}
class Listing {
  static fromProto(proto) {
    let m = new Listing();
    m = Object.assign(m, proto);
    if (proto.reviewCount) {
      m.reviewCount = parseInt(proto.reviewCount, 10);
    }
    if (proto.status) {
      m.status = enumStringToValue$e(ListingListingStatus, proto.status);
    }
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.zipCode !== 'undefined') {
      toReturn['zipCode'] = this.zipCode;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.reviewCount !== 'undefined') {
      toReturn['reviewCount'] = this.reviewCount;
    }
    if (typeof this.reviewRating !== 'undefined') {
      toReturn['reviewRating'] = this.reviewRating;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.sourceName !== 'undefined') {
      toReturn['sourceName'] = this.sourceName;
    }
    if (typeof this.sourceIconUrl !== 'undefined') {
      toReturn['sourceIconUrl'] = this.sourceIconUrl;
    }
    if (typeof this.companyNameMatch !== 'undefined') {
      toReturn['companyNameMatch'] = this.companyNameMatch;
    }
    if (typeof this.addressMatch !== 'undefined') {
      toReturn['addressMatch'] = this.addressMatch;
    }
    if (typeof this.phoneMatch !== 'undefined') {
      toReturn['phoneMatch'] = this.phoneMatch;
    }
    return toReturn;
  }
}
class ListingAccuracy {
  static fromProto(proto) {
    let m = new ListingAccuracy();
    m = Object.assign(m, proto);
    if (proto.incorrectPhoneNumber) {
      m.incorrectPhoneNumber = InaccurateData.fromProto(proto.incorrectPhoneNumber);
    }
    if (proto.missingPhoneNumber) {
      m.missingPhoneNumber = InaccurateData.fromProto(proto.missingPhoneNumber);
    }
    if (proto.incorrectAddress) {
      m.incorrectAddress = InaccurateData.fromProto(proto.incorrectAddress);
    }
    if (proto.missingAddress) {
      m.missingAddress = InaccurateData.fromProto(proto.missingAddress);
    }
    if (proto.incorrectWebsite) {
      m.incorrectWebsite = InaccurateData.fromProto(proto.incorrectWebsite);
    }
    if (proto.missingWebsite) {
      m.missingWebsite = InaccurateData.fromProto(proto.missingWebsite);
    }
    if (proto.competitors) {
      m.competitors = proto.competitors.map(ListingAccuracyCompetitor.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accurateListings !== 'undefined') {
      toReturn['accurateListings'] = this.accurateListings;
    }
    if (typeof this.industryAverageAccurateListings !== 'undefined') {
      toReturn['industryAverageAccurateListings'] = this.industryAverageAccurateListings;
    }
    if (typeof this.incorrectPhoneNumber !== 'undefined' && this.incorrectPhoneNumber !== null) {
      toReturn['incorrectPhoneNumber'] = 'toApiJson' in this.incorrectPhoneNumber ? this.incorrectPhoneNumber.toApiJson() : this.incorrectPhoneNumber;
    }
    if (typeof this.missingPhoneNumber !== 'undefined' && this.missingPhoneNumber !== null) {
      toReturn['missingPhoneNumber'] = 'toApiJson' in this.missingPhoneNumber ? this.missingPhoneNumber.toApiJson() : this.missingPhoneNumber;
    }
    if (typeof this.incorrectAddress !== 'undefined' && this.incorrectAddress !== null) {
      toReturn['incorrectAddress'] = 'toApiJson' in this.incorrectAddress ? this.incorrectAddress.toApiJson() : this.incorrectAddress;
    }
    if (typeof this.missingAddress !== 'undefined' && this.missingAddress !== null) {
      toReturn['missingAddress'] = 'toApiJson' in this.missingAddress ? this.missingAddress.toApiJson() : this.missingAddress;
    }
    if (typeof this.incorrectWebsite !== 'undefined' && this.incorrectWebsite !== null) {
      toReturn['incorrectWebsite'] = 'toApiJson' in this.incorrectWebsite ? this.incorrectWebsite.toApiJson() : this.incorrectWebsite;
    }
    if (typeof this.missingWebsite !== 'undefined' && this.missingWebsite !== null) {
      toReturn['missingWebsite'] = 'toApiJson' in this.missingWebsite ? this.missingWebsite.toApiJson() : this.missingWebsite;
    }
    if (typeof this.competitors !== 'undefined' && this.competitors !== null) {
      toReturn['competitors'] = 'toApiJson' in this.competitors ? this.competitors.toApiJson() : this.competitors;
    }
    return toReturn;
  }
}
class ListingConfig {
  static fromProto(proto) {
    let m = new ListingConfig();
    m = Object.assign(m, proto);
    if (proto.listingPresenceVersion) {
      m.listingPresenceVersion = parseInt(proto.listingPresenceVersion, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hideContent !== 'undefined') {
      toReturn['hideContent'] = this.hideContent;
    }
    if (typeof this.customizedMessage !== 'undefined') {
      toReturn['customizedMessage'] = this.customizedMessage;
    }
    if (typeof this.hideListingPresence !== 'undefined') {
      toReturn['hideListingPresence'] = this.hideListingPresence;
    }
    if (typeof this.hideListingPresenceFacebook !== 'undefined') {
      toReturn['hideListingPresenceFacebook'] = this.hideListingPresenceFacebook;
    }
    if (typeof this.hideListingPresenceTwitter !== 'undefined') {
      toReturn['hideListingPresenceTwitter'] = this.hideListingPresenceTwitter;
    }
    if (typeof this.hideListingPresenceGoogle !== 'undefined') {
      toReturn['hideListingPresenceGoogle'] = this.hideListingPresenceGoogle;
    }
    if (typeof this.hideListingPresenceMissing !== 'undefined') {
      toReturn['hideListingPresenceMissing'] = this.hideListingPresenceMissing;
    }
    if (typeof this.hideListingAccuracy !== 'undefined') {
      toReturn['hideListingAccuracy'] = this.hideListingAccuracy;
    }
    if (typeof this.hideListingAccuracyMissingPhone !== 'undefined') {
      toReturn['hideListingAccuracyMissingPhone'] = this.hideListingAccuracyMissingPhone;
    }
    if (typeof this.hideListingAccuracyIncorrectPhone !== 'undefined') {
      toReturn['hideListingAccuracyIncorrectPhone'] = this.hideListingAccuracyIncorrectPhone;
    }
    if (typeof this.hideListingAccuracyMissingAddress !== 'undefined') {
      toReturn['hideListingAccuracyMissingAddress'] = this.hideListingAccuracyMissingAddress;
    }
    if (typeof this.hideListingAccuracyIncorrectAddress !== 'undefined') {
      toReturn['hideListingAccuracyIncorrectAddress'] = this.hideListingAccuracyIncorrectAddress;
    }
    if (typeof this.hideListingAccuracyMissingWebsite !== 'undefined') {
      toReturn['hideListingAccuracyMissingWebsite'] = this.hideListingAccuracyMissingWebsite;
    }
    if (typeof this.hideListingAccuracyIncorrectWebsite !== 'undefined') {
      toReturn['hideListingAccuracyIncorrectWebsite'] = this.hideListingAccuracyIncorrectWebsite;
    }
    if (typeof this.hideListingDistribution !== 'undefined') {
      toReturn['hideListingDistribution'] = this.hideListingDistribution;
    }
    if (typeof this.hideListingDistributionContent !== 'undefined') {
      toReturn['hideListingDistributionContent'] = this.hideListingDistributionContent;
    }
    if (typeof this.customizedListingDistributionMessage !== 'undefined') {
      toReturn['customizedListingDistributionMessage'] = this.customizedListingDistributionMessage;
    }
    if (typeof this.hideListingPresenceFoursquare !== 'undefined') {
      toReturn['hideListingPresenceFoursquare'] = this.hideListingPresenceFoursquare;
    }
    if (typeof this.hideFooter !== 'undefined') {
      toReturn['hideFooter'] = this.hideFooter;
    }
    if (typeof this.hideListingScan !== 'undefined') {
      toReturn['hideListingScan'] = this.hideListingScan;
    }
    if (typeof this.customizedFooterMessage !== 'undefined') {
      toReturn['customizedFooterMessage'] = this.customizedFooterMessage;
    }
    if (typeof this.customizedFooterCtaLabel !== 'undefined') {
      toReturn['customizedFooterCtaLabel'] = this.customizedFooterCtaLabel;
    }
    if (typeof this.customizedFooterCtaTargetUrl !== 'undefined') {
      toReturn['customizedFooterCtaTargetUrl'] = this.customizedFooterCtaTargetUrl;
    }
    if (typeof this.customizedFooterCtaTargetProduct !== 'undefined') {
      toReturn['customizedFooterCtaTargetProduct'] = this.customizedFooterCtaTargetProduct;
    }
    if (typeof this.hideListingDetails !== 'undefined') {
      toReturn['hideListingDetails'] = this.hideListingDetails;
    }
    if (typeof this.hideListingPresenceInstagram !== 'undefined') {
      toReturn['hideListingPresenceInstagram'] = this.hideListingPresenceInstagram;
    }
    if (typeof this.listingPresenceVersion !== 'undefined') {
      toReturn['listingPresenceVersion'] = this.listingPresenceVersion;
    }
    return toReturn;
  }
}
class ListingData {
  static fromProto(proto) {
    let m = new ListingData();
    m = Object.assign(m, proto);
    if (proto.listingPresence) {
      m.listingPresence = ListingPresence.fromProto(proto.listingPresence);
    }
    if (proto.listingAccuracy) {
      m.listingAccuracy = ListingAccuracy.fromProto(proto.listingAccuracy);
    }
    if (proto.dataProviderAccuracy) {
      m.dataProviderAccuracy = DataProviderAccuracy.fromProto(proto.dataProviderAccuracy);
    }
    if (proto.listingScan) {
      m.listingScan = ListingScan.fromProto(proto.listingScan);
    }
    if (proto.listings) {
      m.listings = Listings.fromProto(proto.listings);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listingPresence !== 'undefined' && this.listingPresence !== null) {
      toReturn['listingPresence'] = 'toApiJson' in this.listingPresence ? this.listingPresence.toApiJson() : this.listingPresence;
    }
    if (typeof this.listingAccuracy !== 'undefined' && this.listingAccuracy !== null) {
      toReturn['listingAccuracy'] = 'toApiJson' in this.listingAccuracy ? this.listingAccuracy.toApiJson() : this.listingAccuracy;
    }
    if (typeof this.dataProviderAccuracy !== 'undefined' && this.dataProviderAccuracy !== null) {
      toReturn['dataProviderAccuracy'] = 'toApiJson' in this.dataProviderAccuracy ? this.dataProviderAccuracy.toApiJson() : this.dataProviderAccuracy;
    }
    if (typeof this.listingScan !== 'undefined' && this.listingScan !== null) {
      toReturn['listingScan'] = 'toApiJson' in this.listingScan ? this.listingScan.toApiJson() : this.listingScan;
    }
    if (typeof this.listings !== 'undefined' && this.listings !== null) {
      toReturn['listings'] = 'toApiJson' in this.listings ? this.listings.toApiJson() : this.listings;
    }
    return toReturn;
  }
}
class ListingV2ListingField {
  static fromProto(proto) {
    let m = new ListingV2ListingField();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.match !== 'undefined') {
      toReturn['match'] = this.match;
    }
    if (typeof this.ignore !== 'undefined') {
      toReturn['ignore'] = this.ignore;
    }
    return toReturn;
  }
}
class ListingPresence {
  static fromProto(proto) {
    let m = new ListingPresence();
    m = Object.assign(m, proto);
    if (proto.foundCount) {
      m.foundCount = parseInt(proto.foundCount, 10);
    }
    if (proto.facebook) {
      m.facebook = ListingSource.fromProto(proto.facebook);
    }
    if (proto.twitter) {
      m.twitter = ListingSource.fromProto(proto.twitter);
    }
    if (proto.foursquare) {
      m.foursquare = ListingSource.fromProto(proto.foursquare);
    }
    if (proto.google) {
      m.google = ListingSource.fromProto(proto.google);
    }
    if (proto.availableSources) {
      m.availableSources = parseInt(proto.availableSources, 10);
    }
    if (proto.competitors) {
      m.competitors = proto.competitors.map(ListingPresenceCompetitor.fromProto);
    }
    if (proto.instagram) {
      m.instagram = ListingSource.fromProto(proto.instagram);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.foundCount !== 'undefined') {
      toReturn['foundCount'] = this.foundCount;
    }
    if (typeof this.industryAverageFound !== 'undefined') {
      toReturn['industryAverageFound'] = this.industryAverageFound;
    }
    if (typeof this.facebook !== 'undefined' && this.facebook !== null) {
      toReturn['facebook'] = 'toApiJson' in this.facebook ? this.facebook.toApiJson() : this.facebook;
    }
    if (typeof this.twitter !== 'undefined' && this.twitter !== null) {
      toReturn['twitter'] = 'toApiJson' in this.twitter ? this.twitter.toApiJson() : this.twitter;
    }
    if (typeof this.foursquare !== 'undefined' && this.foursquare !== null) {
      toReturn['foursquare'] = 'toApiJson' in this.foursquare ? this.foursquare.toApiJson() : this.foursquare;
    }
    if (typeof this.google !== 'undefined' && this.google !== null) {
      toReturn['google'] = 'toApiJson' in this.google ? this.google.toApiJson() : this.google;
    }
    if (typeof this.availableSources !== 'undefined') {
      toReturn['availableSources'] = this.availableSources;
    }
    if (typeof this.competitors !== 'undefined' && this.competitors !== null) {
      toReturn['competitors'] = 'toApiJson' in this.competitors ? this.competitors.toApiJson() : this.competitors;
    }
    if (typeof this.instagram !== 'undefined' && this.instagram !== null) {
      toReturn['instagram'] = 'toApiJson' in this.instagram ? this.instagram.toApiJson() : this.instagram;
    }
    return toReturn;
  }
}
class ListingScan {
  static fromProto(proto) {
    let m = new ListingScan();
    m = Object.assign(m, proto);
    if (proto.listings) {
      m.listings = proto.listings.map(Listing.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listings !== 'undefined' && this.listings !== null) {
      toReturn['listings'] = 'toApiJson' in this.listings ? this.listings.toApiJson() : this.listings;
    }
    return toReturn;
  }
}
class ListingSection {
  static fromProto(proto) {
    let m = new ListingSection();
    m = Object.assign(m, proto);
    if (proto.grade) {
      m.grade = enumStringToValue$e(Grade, proto.grade);
    }
    if (proto.content) {
      m.content = SectionContent.fromProto(proto.content);
    }
    if (proto.data) {
      m.data = ListingData.fromProto(proto.data);
    }
    if (proto.config) {
      m.config = ListingConfig.fromProto(proto.config);
    }
    if (proto.listingDistributionContent) {
      m.listingDistributionContent = SectionContent.fromProto(proto.listingDistributionContent);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.grade !== 'undefined') {
      toReturn['grade'] = this.grade;
    }
    if (typeof this.content !== 'undefined' && this.content !== null) {
      toReturn['content'] = 'toApiJson' in this.content ? this.content.toApiJson() : this.content;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    if (typeof this.listingDistributionContent !== 'undefined' && this.listingDistributionContent !== null) {
      toReturn['listingDistributionContent'] = 'toApiJson' in this.listingDistributionContent ? this.listingDistributionContent.toApiJson() : this.listingDistributionContent;
    }
    return toReturn;
  }
}
class ListingSource {
  static fromProto(proto) {
    let m = new ListingSource();
    m = Object.assign(m, proto);
    if (proto.foundCount) {
      m.foundCount = parseInt(proto.foundCount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.foundCount !== 'undefined') {
      toReturn['foundCount'] = this.foundCount;
    }
    if (typeof this.exampleListingUrl !== 'undefined') {
      toReturn['exampleListingUrl'] = this.exampleListingUrl;
    }
    if (typeof this.industryAverageFound !== 'undefined') {
      toReturn['industryAverageFound'] = this.industryAverageFound;
    }
    return toReturn;
  }
}
class ListingV2 {
  static fromProto(proto) {
    let m = new ListingV2();
    m = Object.assign(m, proto);
    if (proto.companyName) {
      m.companyName = ListingV2ListingField.fromProto(proto.companyName);
    }
    if (proto.address) {
      m.address = ListingV2ListingField.fromProto(proto.address);
    }
    if (proto.city) {
      m.city = ListingV2ListingField.fromProto(proto.city);
    }
    if (proto.state) {
      m.state = ListingV2ListingField.fromProto(proto.state);
    }
    if (proto.zip) {
      m.zip = ListingV2ListingField.fromProto(proto.zip);
    }
    if (proto.website) {
      m.website = ListingV2ListingField.fromProto(proto.website);
    }
    if (proto.phone) {
      m.phone = ListingV2ListingField.fromProto(proto.phone);
    }
    if (proto.status) {
      m.status = enumStringToValue$e(ListingV2ListingStatus, proto.status);
    }
    if (proto.source) {
      m.source = ListingV2Source.fromProto(proto.source);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.companyName !== 'undefined' && this.companyName !== null) {
      toReturn['companyName'] = 'toApiJson' in this.companyName ? this.companyName.toApiJson() : this.companyName;
    }
    if (typeof this.address !== 'undefined' && this.address !== null) {
      toReturn['address'] = 'toApiJson' in this.address ? this.address.toApiJson() : this.address;
    }
    if (typeof this.city !== 'undefined' && this.city !== null) {
      toReturn['city'] = 'toApiJson' in this.city ? this.city.toApiJson() : this.city;
    }
    if (typeof this.state !== 'undefined' && this.state !== null) {
      toReturn['state'] = 'toApiJson' in this.state ? this.state.toApiJson() : this.state;
    }
    if (typeof this.zip !== 'undefined' && this.zip !== null) {
      toReturn['zip'] = 'toApiJson' in this.zip ? this.zip.toApiJson() : this.zip;
    }
    if (typeof this.website !== 'undefined' && this.website !== null) {
      toReturn['website'] = 'toApiJson' in this.website ? this.website.toApiJson() : this.website;
    }
    if (typeof this.phone !== 'undefined' && this.phone !== null) {
      toReturn['phone'] = 'toApiJson' in this.phone ? this.phone.toApiJson() : this.phone;
    }
    if (typeof this.listingUrl !== 'undefined') {
      toReturn['listingUrl'] = this.listingUrl;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.source !== 'undefined' && this.source !== null) {
      toReturn['source'] = 'toApiJson' in this.source ? this.source.toApiJson() : this.source;
    }
    return toReturn;
  }
}
class Listings {
  static fromProto(proto) {
    let m = new Listings();
    m = Object.assign(m, proto);
    if (proto.listings) {
      m.listings = proto.listings.map(ListingV2.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listings !== 'undefined' && this.listings !== null) {
      toReturn['listings'] = 'toApiJson' in this.listings ? this.listings.toApiJson() : this.listings;
    }
    return toReturn;
  }
}
class ListingV2Source {
  static fromProto(proto) {
    let m = new ListingV2Source();
    m = Object.assign(m, proto);
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.sourceName !== 'undefined') {
      toReturn['sourceName'] = this.sourceName;
    }
    if (typeof this.sourceIconUrl !== 'undefined') {
      toReturn['sourceIconUrl'] = this.sourceIconUrl;
    }
    return toReturn;
  }
}
function enumStringToValue$d(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ReviewDataCompetitor {
  static fromProto(proto) {
    let m = new ReviewDataCompetitor();
    m = Object.assign(m, proto);
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.reviewsFound !== 'undefined') {
      toReturn['reviewsFound'] = this.reviewsFound;
    }
    if (typeof this.averageReviewScore !== 'undefined') {
      toReturn['averageReviewScore'] = this.averageReviewScore;
    }
    if (typeof this.numberOfReviewSources !== 'undefined') {
      toReturn['numberOfReviewSources'] = this.numberOfReviewSources;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.reviewsFoundPerMonth !== 'undefined') {
      toReturn['reviewsFoundPerMonth'] = this.reviewsFoundPerMonth;
    }
    return toReturn;
  }
}
class ReviewConfig {
  static fromProto(proto) {
    let m = new ReviewConfig();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hideContent !== 'undefined') {
      toReturn['hideContent'] = this.hideContent;
    }
    if (typeof this.hideReviewsFound !== 'undefined') {
      toReturn['hideReviewsFound'] = this.hideReviewsFound;
    }
    if (typeof this.hideReviewsFoundPerMonth !== 'undefined') {
      toReturn['hideReviewsFoundPerMonth'] = this.hideReviewsFoundPerMonth;
    }
    if (typeof this.hideAverageReviewScore !== 'undefined') {
      toReturn['hideAverageReviewScore'] = this.hideAverageReviewScore;
    }
    if (typeof this.hideNumberOfReviewSources !== 'undefined') {
      toReturn['hideNumberOfReviewSources'] = this.hideNumberOfReviewSources;
    }
    if (typeof this.customizedMessage !== 'undefined') {
      toReturn['customizedMessage'] = this.customizedMessage;
    }
    if (typeof this.hideFooter !== 'undefined') {
      toReturn['hideFooter'] = this.hideFooter;
    }
    if (typeof this.customizedFooterMessage !== 'undefined') {
      toReturn['customizedFooterMessage'] = this.customizedFooterMessage;
    }
    if (typeof this.customizedFooterCtaLabel !== 'undefined') {
      toReturn['customizedFooterCtaLabel'] = this.customizedFooterCtaLabel;
    }
    if (typeof this.customizedFooterCtaTargetUrl !== 'undefined') {
      toReturn['customizedFooterCtaTargetUrl'] = this.customizedFooterCtaTargetUrl;
    }
    if (typeof this.customizedFooterCtaTargetProduct !== 'undefined') {
      toReturn['customizedFooterCtaTargetProduct'] = this.customizedFooterCtaTargetProduct;
    }
    return toReturn;
  }
}
class ReviewData {
  static fromProto(proto) {
    let m = new ReviewData();
    m = Object.assign(m, proto);
    if (proto.reviewsFound) {
      m.reviewsFound = ReviewDataItem.fromProto(proto.reviewsFound);
    }
    if (proto.reviewsFoundPerMonth) {
      m.reviewsFoundPerMonth = ReviewDataItem.fromProto(proto.reviewsFoundPerMonth);
    }
    if (proto.averageReviewScore) {
      m.averageReviewScore = ReviewDataItem.fromProto(proto.averageReviewScore);
    }
    if (proto.numberOfReviewSources) {
      m.numberOfReviewSources = ReviewDataItem.fromProto(proto.numberOfReviewSources);
    }
    if (proto.sampleSourceCounts) {
      m.sampleSourceCounts = proto.sampleSourceCounts.map(SampleSourceCount.fromProto);
    }
    if (proto.competitors) {
      m.competitors = proto.competitors.map(ReviewDataCompetitor.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewsFound !== 'undefined' && this.reviewsFound !== null) {
      toReturn['reviewsFound'] = 'toApiJson' in this.reviewsFound ? this.reviewsFound.toApiJson() : this.reviewsFound;
    }
    if (typeof this.reviewsFoundPerMonth !== 'undefined' && this.reviewsFoundPerMonth !== null) {
      toReturn['reviewsFoundPerMonth'] = 'toApiJson' in this.reviewsFoundPerMonth ? this.reviewsFoundPerMonth.toApiJson() : this.reviewsFoundPerMonth;
    }
    if (typeof this.averageReviewScore !== 'undefined' && this.averageReviewScore !== null) {
      toReturn['averageReviewScore'] = 'toApiJson' in this.averageReviewScore ? this.averageReviewScore.toApiJson() : this.averageReviewScore;
    }
    if (typeof this.numberOfReviewSources !== 'undefined' && this.numberOfReviewSources !== null) {
      toReturn['numberOfReviewSources'] = 'toApiJson' in this.numberOfReviewSources ? this.numberOfReviewSources.toApiJson() : this.numberOfReviewSources;
    }
    if (typeof this.sampleSourceCounts !== 'undefined' && this.sampleSourceCounts !== null) {
      toReturn['sampleSourceCounts'] = 'toApiJson' in this.sampleSourceCounts ? this.sampleSourceCounts.toApiJson() : this.sampleSourceCounts;
    }
    if (typeof this.competitors !== 'undefined' && this.competitors !== null) {
      toReturn['competitors'] = 'toApiJson' in this.competitors ? this.competitors.toApiJson() : this.competitors;
    }
    return toReturn;
  }
}
class ReviewDataItem {
  static fromProto(proto) {
    let m = new ReviewDataItem();
    m = Object.assign(m, proto);
    if (proto.grade) {
      m.grade = enumStringToValue$d(Grade, proto.grade);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.grade !== 'undefined') {
      toReturn['grade'] = this.grade;
    }
    if (typeof this.business !== 'undefined') {
      toReturn['business'] = this.business;
    }
    if (typeof this.industryAverage !== 'undefined') {
      toReturn['industryAverage'] = this.industryAverage;
    }
    if (typeof this.industryLeader !== 'undefined') {
      toReturn['industryLeader'] = this.industryLeader;
    }
    return toReturn;
  }
}
class ReviewSection {
  static fromProto(proto) {
    let m = new ReviewSection();
    m = Object.assign(m, proto);
    if (proto.grade) {
      m.grade = enumStringToValue$d(Grade, proto.grade);
    }
    if (proto.content) {
      m.content = SectionContent.fromProto(proto.content);
    }
    if (proto.data) {
      m.data = ReviewData.fromProto(proto.data);
    }
    if (proto.config) {
      m.config = ReviewConfig.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.grade !== 'undefined') {
      toReturn['grade'] = this.grade;
    }
    if (typeof this.content !== 'undefined' && this.content !== null) {
      toReturn['content'] = 'toApiJson' in this.content ? this.content.toApiJson() : this.content;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
class SampleSourceCount {
  static fromProto(proto) {
    let m = new SampleSourceCount();
    m = Object.assign(m, proto);
    if (proto.reviewCount) {
      m.reviewCount = parseInt(proto.reviewCount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceName !== 'undefined') {
      toReturn['sourceName'] = this.sourceName;
    }
    if (typeof this.reviewCount !== 'undefined') {
      toReturn['reviewCount'] = this.reviewCount;
    }
    return toReturn;
  }
}
function enumStringToValue$c(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Keyword {
  static fromProto(proto) {
    let m = new Keyword();
    m = Object.assign(m, proto);
    if (proto.position) {
      m.position = parseInt(proto.position, 10);
    }
    if (proto.difficulty) {
      m.difficulty = parseInt(proto.difficulty, 10);
    }
    if (proto.monthlySearchVolume) {
      m.monthlySearchVolume = parseInt(proto.monthlySearchVolume, 10);
    }
    if (proto.monthlyLocalSearchVolume) {
      m.monthlyLocalSearchVolume = parseInt(proto.monthlyLocalSearchVolume, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.term !== 'undefined') {
      toReturn['term'] = this.term;
    }
    if (typeof this.position !== 'undefined') {
      toReturn['position'] = this.position;
    }
    if (typeof this.difficulty !== 'undefined') {
      toReturn['difficulty'] = this.difficulty;
    }
    if (typeof this.monthlyClicks !== 'undefined') {
      toReturn['monthlyClicks'] = this.monthlyClicks;
    }
    if (typeof this.monthlySearchVolume !== 'undefined') {
      toReturn['monthlySearchVolume'] = this.monthlySearchVolume;
    }
    if (typeof this.monthlyLocalSearchVolume !== 'undefined') {
      toReturn['monthlyLocalSearchVolume'] = this.monthlyLocalSearchVolume;
    }
    return toReturn;
  }
}
class KeywordMetrics {
  static fromProto(proto) {
    let m = new KeywordMetrics();
    m = Object.assign(m, proto);
    if (proto.keywords) {
      m.keywords = proto.keywords.map(Keyword.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domainName !== 'undefined') {
      toReturn['domainName'] = this.domainName;
    }
    if (typeof this.keywords !== 'undefined' && this.keywords !== null) {
      toReturn['keywords'] = 'toApiJson' in this.keywords ? this.keywords.toApiJson() : this.keywords;
    }
    return toReturn;
  }
}
class LatLng {
  static fromProto(proto) {
    let m = new LatLng();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.lat !== 'undefined') {
      toReturn['lat'] = this.lat;
    }
    if (typeof this.lng !== 'undefined') {
      toReturn['lng'] = this.lng;
    }
    if (typeof this.latitude !== 'undefined') {
      toReturn['latitude'] = this.latitude;
    }
    if (typeof this.longitude !== 'undefined') {
      toReturn['longitude'] = this.longitude;
    }
    return toReturn;
  }
}
class LocalSEOData {
  static fromProto(proto) {
    let m = new LocalSEOData();
    m = Object.assign(m, proto);
    if (proto.searches) {
      m.searches = proto.searches.map(SERPMetrics.fromProto);
    }
    if (proto.grade) {
      m.grade = enumStringToValue$c(Grade, proto.grade);
    }
    if (proto.status) {
      m.status = enumStringToValue$c(Status, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searches !== 'undefined' && this.searches !== null) {
      toReturn['searches'] = 'toApiJson' in this.searches ? this.searches.toApiJson() : this.searches;
    }
    if (typeof this.grade !== 'undefined') {
      toReturn['grade'] = this.grade;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.searchKeyword !== 'undefined') {
      toReturn['searchKeyword'] = this.searchKeyword;
    }
    return toReturn;
  }
}
class OrganicDomainData {
  static fromProto(proto) {
    let m = new OrganicDomainData();
    m = Object.assign(m, proto);
    if (proto.business) {
      m.business = SEODomainMetrics.fromProto(proto.business);
    }
    if (proto.competitors) {
      m.competitors = proto.competitors.map(SEODomainMetrics.fromProto);
    }
    if (proto.grade) {
      m.grade = enumStringToValue$c(Grade, proto.grade);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.business !== 'undefined' && this.business !== null) {
      toReturn['business'] = 'toApiJson' in this.business ? this.business.toApiJson() : this.business;
    }
    if (typeof this.competitors !== 'undefined' && this.competitors !== null) {
      toReturn['competitors'] = 'toApiJson' in this.competitors ? this.competitors.toApiJson() : this.competitors;
    }
    if (typeof this.grade !== 'undefined') {
      toReturn['grade'] = this.grade;
    }
    return toReturn;
  }
}
class OrganicKeywordData {
  static fromProto(proto) {
    let m = new OrganicKeywordData();
    m = Object.assign(m, proto);
    if (proto.business) {
      m.business = KeywordMetrics.fromProto(proto.business);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.business !== 'undefined' && this.business !== null) {
      toReturn['business'] = 'toApiJson' in this.business ? this.business.toApiJson() : this.business;
    }
    return toReturn;
  }
}
class Results {
  static fromProto(proto) {
    let m = new Results();
    m = Object.assign(m, proto);
    if (proto.rank) {
      m.rank = parseInt(proto.rank, 10);
    }
    if (proto.reviews) {
      m.reviews = ResultsReviews.fromProto(proto.reviews);
    }
    if (proto.claimStatus) {
      m.claimStatus = enumStringToValue$c(GMBClaimStatus, proto.claimStatus);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessName !== 'undefined') {
      toReturn['businessName'] = this.businessName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.rank !== 'undefined') {
      toReturn['rank'] = this.rank;
    }
    if (typeof this.isMainBusiness !== 'undefined') {
      toReturn['isMainBusiness'] = this.isMainBusiness;
    }
    if (typeof this.reviews !== 'undefined' && this.reviews !== null) {
      toReturn['reviews'] = 'toApiJson' in this.reviews ? this.reviews.toApiJson() : this.reviews;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.claimStatus !== 'undefined') {
      toReturn['claimStatus'] = this.claimStatus;
    }
    return toReturn;
  }
}
class ResultsReviews {
  static fromProto(proto) {
    let m = new ResultsReviews();
    m = Object.assign(m, proto);
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.rating !== 'undefined') {
      toReturn['rating'] = this.rating;
    }
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    return toReturn;
  }
}
class SEOConfig {
  static fromProto(proto) {
    let m = new SEOConfig();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hideContent !== 'undefined') {
      toReturn['hideContent'] = this.hideContent;
    }
    if (typeof this.customizedMessage !== 'undefined') {
      toReturn['customizedMessage'] = this.customizedMessage;
    }
    if (typeof this.hideFooter !== 'undefined') {
      toReturn['hideFooter'] = this.hideFooter;
    }
    if (typeof this.hideOrganicSeoData !== 'undefined') {
      toReturn['hideOrganicSeoData'] = this.hideOrganicSeoData;
    }
    if (typeof this.hideOrganicKeywordData !== 'undefined') {
      toReturn['hideOrganicKeywordData'] = this.hideOrganicKeywordData;
    }
    if (typeof this.customizedFooterMessage !== 'undefined') {
      toReturn['customizedFooterMessage'] = this.customizedFooterMessage;
    }
    if (typeof this.customizedFooterCtaLabel !== 'undefined') {
      toReturn['customizedFooterCtaLabel'] = this.customizedFooterCtaLabel;
    }
    if (typeof this.customizedFooterCtaTargetUrl !== 'undefined') {
      toReturn['customizedFooterCtaTargetUrl'] = this.customizedFooterCtaTargetUrl;
    }
    if (typeof this.customizedFooterCtaTargetProduct !== 'undefined') {
      toReturn['customizedFooterCtaTargetProduct'] = this.customizedFooterCtaTargetProduct;
    }
    if (typeof this.hideLocalSeoData !== 'undefined') {
      toReturn['hideLocalSeoData'] = this.hideLocalSeoData;
    }
    if (typeof this.customKeyword !== 'undefined') {
      toReturn['customKeyword'] = this.customKeyword;
    }
    return toReturn;
  }
}
class SEOData {
  static fromProto(proto) {
    let m = new SEOData();
    m = Object.assign(m, proto);
    if (proto.organicDomainData) {
      m.organicDomainData = OrganicDomainData.fromProto(proto.organicDomainData);
    }
    if (proto.organicKeywordData) {
      m.organicKeywordData = OrganicKeywordData.fromProto(proto.organicKeywordData);
    }
    if (proto.localSeoData) {
      m.localSeoData = LocalSEOData.fromProto(proto.localSeoData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.organicDomainData !== 'undefined' && this.organicDomainData !== null) {
      toReturn['organicDomainData'] = 'toApiJson' in this.organicDomainData ? this.organicDomainData.toApiJson() : this.organicDomainData;
    }
    if (typeof this.organicKeywordData !== 'undefined' && this.organicKeywordData !== null) {
      toReturn['organicKeywordData'] = 'toApiJson' in this.organicKeywordData ? this.organicKeywordData.toApiJson() : this.organicKeywordData;
    }
    if (typeof this.localSeoData !== 'undefined' && this.localSeoData !== null) {
      toReturn['localSeoData'] = 'toApiJson' in this.localSeoData ? this.localSeoData.toApiJson() : this.localSeoData;
    }
    return toReturn;
  }
}
class SEODomainMetrics {
  static fromProto(proto) {
    let m = new SEODomainMetrics();
    m = Object.assign(m, proto);
    if (proto.numberOfOrganicKeywords) {
      m.numberOfOrganicKeywords = parseInt(proto.numberOfOrganicKeywords, 10);
    }
    if (proto.organicClicksPerMonth) {
      m.organicClicksPerMonth = parseInt(proto.organicClicksPerMonth, 10);
    }
    if (proto.dailyOrganicTrafficValue) {
      m.dailyOrganicTrafficValue = parseInt(proto.dailyOrganicTrafficValue, 10);
    }
    if (proto.organicDomainRanking) {
      m.organicDomainRanking = parseInt(proto.organicDomainRanking, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domainName !== 'undefined') {
      toReturn['domainName'] = this.domainName;
    }
    if (typeof this.numberOfOrganicKeywords !== 'undefined') {
      toReturn['numberOfOrganicKeywords'] = this.numberOfOrganicKeywords;
    }
    if (typeof this.organicClicksPerMonth !== 'undefined') {
      toReturn['organicClicksPerMonth'] = this.organicClicksPerMonth;
    }
    if (typeof this.dailyOrganicTrafficValue !== 'undefined') {
      toReturn['dailyOrganicTrafficValue'] = this.dailyOrganicTrafficValue;
    }
    if (typeof this.organicDomainRanking !== 'undefined') {
      toReturn['organicDomainRanking'] = this.organicDomainRanking;
    }
    if (typeof this.overlap !== 'undefined') {
      toReturn['overlap'] = this.overlap;
    }
    if (typeof this.valuePerClick !== 'undefined') {
      toReturn['valuePerClick'] = this.valuePerClick;
    }
    return toReturn;
  }
}
class SEOSection {
  static fromProto(proto) {
    let m = new SEOSection();
    m = Object.assign(m, proto);
    if (proto.grade) {
      m.grade = enumStringToValue$c(Grade, proto.grade);
    }
    if (proto.content) {
      m.content = SectionContent.fromProto(proto.content);
    }
    if (proto.data) {
      m.data = SEOData.fromProto(proto.data);
    }
    if (proto.config) {
      m.config = SEOConfig.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.grade !== 'undefined') {
      toReturn['grade'] = this.grade;
    }
    if (typeof this.content !== 'undefined' && this.content !== null) {
      toReturn['content'] = 'toApiJson' in this.content ? this.content.toApiJson() : this.content;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
class SERPMetrics {
  static fromProto(proto) {
    let m = new SERPMetrics();
    m = Object.assign(m, proto);
    if (proto.vicinity) {
      m.vicinity = enumStringToValue$c(Vicinity, proto.vicinity);
    }
    if (proto.searchLocation) {
      m.searchLocation = LatLng.fromProto(proto.searchLocation);
    }
    if (proto.results) {
      m.results = proto.results.map(Results.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.vicinity !== 'undefined') {
      toReturn['vicinity'] = this.vicinity;
    }
    if (typeof this.searchLocation !== 'undefined' && this.searchLocation !== null) {
      toReturn['searchLocation'] = 'toApiJson' in this.searchLocation ? this.searchLocation.toApiJson() : this.searchLocation;
    }
    if (typeof this.results !== 'undefined' && this.results !== null) {
      toReturn['results'] = 'toApiJson' in this.results ? this.results.toApiJson() : this.results;
    }
    return toReturn;
  }
}
function enumStringToValue$b(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Business {
  static fromProto(proto) {
    let m = new Business();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class SnapshotLite {
  static fromProto(proto) {
    let m = new SnapshotLite();
    m = Object.assign(m, proto);
    if (proto.business) {
      m.business = Business.fromProto(proto.business);
    }
    if (proto.salesPerson) {
      m.salesPerson = SalesPerson.fromProto(proto.salesPerson);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.business !== 'undefined' && this.business !== null) {
      toReturn['business'] = 'toApiJson' in this.business ? this.business.toApiJson() : this.business;
    }
    if (typeof this.salesPerson !== 'undefined' && this.salesPerson !== null) {
      toReturn['salesPerson'] = 'toApiJson' in this.salesPerson ? this.salesPerson.toApiJson() : this.salesPerson;
    }
    return toReturn;
  }
}
function enumStringToValue$a(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class SocialDataCompetitor {
  static fromProto(proto) {
    let m = new SocialDataCompetitor();
    m = Object.assign(m, proto);
    if (proto.facebookData) {
      m.facebookData = SocialDataCompetitorFacebookData.fromProto(proto.facebookData);
    }
    if (proto.twitterData) {
      m.twitterData = SocialDataCompetitorTwitterData.fromProto(proto.twitterData);
    }
    if (proto.instagramData) {
      m.instagramData = SocialDataCompetitorInstagramData.fromProto(proto.instagramData);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.facebookData !== 'undefined' && this.facebookData !== null) {
      toReturn['facebookData'] = 'toApiJson' in this.facebookData ? this.facebookData.toApiJson() : this.facebookData;
    }
    if (typeof this.twitterData !== 'undefined' && this.twitterData !== null) {
      toReturn['twitterData'] = 'toApiJson' in this.twitterData ? this.twitterData.toApiJson() : this.twitterData;
    }
    if (typeof this.instagramData !== 'undefined' && this.instagramData !== null) {
      toReturn['instagramData'] = 'toApiJson' in this.instagramData ? this.instagramData.toApiJson() : this.instagramData;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
class SocialDataCompetitorFacebookData {
  static fromProto(proto) {
    let m = new SocialDataCompetitorFacebookData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.averageSharesPerPost !== 'undefined') {
      toReturn['averageSharesPerPost'] = this.averageSharesPerPost;
    }
    if (typeof this.averageLikesPerPost !== 'undefined') {
      toReturn['averageLikesPerPost'] = this.averageLikesPerPost;
    }
    if (typeof this.likes !== 'undefined') {
      toReturn['likes'] = this.likes;
    }
    if (typeof this.averagePostsPerMonth !== 'undefined') {
      toReturn['averagePostsPerMonth'] = this.averagePostsPerMonth;
    }
    return toReturn;
  }
}
class FacebookData {
  static fromProto(proto) {
    let m = new FacebookData();
    m = Object.assign(m, proto);
    if (proto.averageSharesPerPost) {
      m.averageSharesPerPost = SocialDataItem.fromProto(proto.averageSharesPerPost);
    }
    if (proto.averageLikesPerPost) {
      m.averageLikesPerPost = SocialDataItem.fromProto(proto.averageLikesPerPost);
    }
    if (proto.likes) {
      m.likes = SocialDataItem.fromProto(proto.likes);
    }
    if (proto.posts) {
      m.posts = SocialDataItem.fromProto(proto.posts);
    }
    if (proto.recentPosts) {
      m.recentPosts = proto.recentPosts.map(FacebookPost.fromProto);
    }
    if (proto.averagePostsPerMonth) {
      m.averagePostsPerMonth = SocialDataItem.fromProto(proto.averagePostsPerMonth);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.averageSharesPerPost !== 'undefined' && this.averageSharesPerPost !== null) {
      toReturn['averageSharesPerPost'] = 'toApiJson' in this.averageSharesPerPost ? this.averageSharesPerPost.toApiJson() : this.averageSharesPerPost;
    }
    if (typeof this.averageLikesPerPost !== 'undefined' && this.averageLikesPerPost !== null) {
      toReturn['averageLikesPerPost'] = 'toApiJson' in this.averageLikesPerPost ? this.averageLikesPerPost.toApiJson() : this.averageLikesPerPost;
    }
    if (typeof this.likes !== 'undefined' && this.likes !== null) {
      toReturn['likes'] = 'toApiJson' in this.likes ? this.likes.toApiJson() : this.likes;
    }
    if (typeof this.posts !== 'undefined' && this.posts !== null) {
      toReturn['posts'] = 'toApiJson' in this.posts ? this.posts.toApiJson() : this.posts;
    }
    if (typeof this.recentPosts !== 'undefined' && this.recentPosts !== null) {
      toReturn['recentPosts'] = 'toApiJson' in this.recentPosts ? this.recentPosts.toApiJson() : this.recentPosts;
    }
    if (typeof this.averagePostsPerMonth !== 'undefined' && this.averagePostsPerMonth !== null) {
      toReturn['averagePostsPerMonth'] = 'toApiJson' in this.averagePostsPerMonth ? this.averagePostsPerMonth.toApiJson() : this.averagePostsPerMonth;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
class FacebookPost {
  static fromProto(proto) {
    let m = new FacebookPost();
    m = Object.assign(m, proto);
    if (proto.posted) {
      m.posted = new Date(proto.posted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.profileImageUrl !== 'undefined') {
      toReturn['profileImageUrl'] = this.profileImageUrl;
    }
    if (typeof this.profileUrl !== 'undefined') {
      toReturn['profileUrl'] = this.profileUrl;
    }
    if (typeof this.posted !== 'undefined' && this.posted !== null) {
      toReturn['posted'] = 'toApiJson' in this.posted ? this.posted.toApiJson() : this.posted;
    }
    if (typeof this.postText !== 'undefined') {
      toReturn['postText'] = this.postText;
    }
    if (typeof this.postUrl !== 'undefined') {
      toReturn['postUrl'] = this.postUrl;
    }
    if (typeof this.profileName !== 'undefined') {
      toReturn['profileName'] = this.profileName;
    }
    return toReturn;
  }
}
class SocialDataCompetitorInstagramData {
  static fromProto(proto) {
    let m = new SocialDataCompetitorInstagramData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.followers !== 'undefined') {
      toReturn['followers'] = this.followers;
    }
    if (typeof this.posts !== 'undefined') {
      toReturn['posts'] = this.posts;
    }
    return toReturn;
  }
}
class InstagramData {
  static fromProto(proto) {
    let m = new InstagramData();
    m = Object.assign(m, proto);
    if (proto.followers) {
      m.followers = SocialDataItem.fromProto(proto.followers);
    }
    if (proto.posts) {
      m.posts = SocialDataItem.fromProto(proto.posts);
    }
    if (proto.status) {
      m.status = enumStringToValue$a(InstagramDataInstagramDataStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.followers !== 'undefined' && this.followers !== null) {
      toReturn['followers'] = 'toApiJson' in this.followers ? this.followers.toApiJson() : this.followers;
    }
    if (typeof this.posts !== 'undefined' && this.posts !== null) {
      toReturn['posts'] = 'toApiJson' in this.posts ? this.posts.toApiJson() : this.posts;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
class SocialConfig {
  static fromProto(proto) {
    let m = new SocialConfig();
    m = Object.assign(m, proto);
    if (proto.selectedFacebookPost) {
      m.selectedFacebookPost = FacebookPost.fromProto(proto.selectedFacebookPost);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hideContent !== 'undefined') {
      toReturn['hideContent'] = this.hideContent;
    }
    if (typeof this.customizedMessage !== 'undefined') {
      toReturn['customizedMessage'] = this.customizedMessage;
    }
    if (typeof this.hideFacebook !== 'undefined') {
      toReturn['hideFacebook'] = this.hideFacebook;
    }
    if (typeof this.hideFacebookLikes !== 'undefined') {
      toReturn['hideFacebookLikes'] = this.hideFacebookLikes;
    }
    if (typeof this.hideFacebookPosts !== 'undefined') {
      toReturn['hideFacebookPosts'] = this.hideFacebookPosts;
    }
    if (typeof this.hideFacebookAverageLikesPerPost !== 'undefined') {
      toReturn['hideFacebookAverageLikesPerPost'] = this.hideFacebookAverageLikesPerPost;
    }
    if (typeof this.hideFacebookAverageSharesPerPost !== 'undefined') {
      toReturn['hideFacebookAverageSharesPerPost'] = this.hideFacebookAverageSharesPerPost;
    }
    if (typeof this.hideFacebookSelectedPost !== 'undefined') {
      toReturn['hideFacebookSelectedPost'] = this.hideFacebookSelectedPost;
    }
    if (typeof this.selectedFacebookPost !== 'undefined' && this.selectedFacebookPost !== null) {
      toReturn['selectedFacebookPost'] = 'toApiJson' in this.selectedFacebookPost ? this.selectedFacebookPost.toApiJson() : this.selectedFacebookPost;
    }
    if (typeof this.hideTwitter !== 'undefined') {
      toReturn['hideTwitter'] = this.hideTwitter;
    }
    if (typeof this.hideTwitterFollowers !== 'undefined') {
      toReturn['hideTwitterFollowers'] = this.hideTwitterFollowers;
    }
    if (typeof this.hideTwitterFollowing !== 'undefined') {
      toReturn['hideTwitterFollowing'] = this.hideTwitterFollowing;
    }
    if (typeof this.hideTwitterTweets !== 'undefined') {
      toReturn['hideTwitterTweets'] = this.hideTwitterTweets;
    }
    if (typeof this.hideFooter !== 'undefined') {
      toReturn['hideFooter'] = this.hideFooter;
    }
    if (typeof this.hideInstagram !== 'undefined') {
      toReturn['hideInstagram'] = this.hideInstagram;
    }
    if (typeof this.customizedFooterMessage !== 'undefined') {
      toReturn['customizedFooterMessage'] = this.customizedFooterMessage;
    }
    if (typeof this.customizedFooterCtaLabel !== 'undefined') {
      toReturn['customizedFooterCtaLabel'] = this.customizedFooterCtaLabel;
    }
    if (typeof this.customizedFooterCtaTargetUrl !== 'undefined') {
      toReturn['customizedFooterCtaTargetUrl'] = this.customizedFooterCtaTargetUrl;
    }
    if (typeof this.customizedFooterCtaTargetProduct !== 'undefined') {
      toReturn['customizedFooterCtaTargetProduct'] = this.customizedFooterCtaTargetProduct;
    }
    return toReturn;
  }
}
class SocialData {
  static fromProto(proto) {
    let m = new SocialData();
    m = Object.assign(m, proto);
    if (proto.facebookData) {
      m.facebookData = FacebookData.fromProto(proto.facebookData);
    }
    if (proto.twitterData) {
      m.twitterData = TwitterData.fromProto(proto.twitterData);
    }
    if (proto.instagramData) {
      m.instagramData = InstagramData.fromProto(proto.instagramData);
    }
    if (proto.competitors) {
      m.competitors = proto.competitors.map(SocialDataCompetitor.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.facebookData !== 'undefined' && this.facebookData !== null) {
      toReturn['facebookData'] = 'toApiJson' in this.facebookData ? this.facebookData.toApiJson() : this.facebookData;
    }
    if (typeof this.twitterData !== 'undefined' && this.twitterData !== null) {
      toReturn['twitterData'] = 'toApiJson' in this.twitterData ? this.twitterData.toApiJson() : this.twitterData;
    }
    if (typeof this.instagramData !== 'undefined' && this.instagramData !== null) {
      toReturn['instagramData'] = 'toApiJson' in this.instagramData ? this.instagramData.toApiJson() : this.instagramData;
    }
    if (typeof this.competitors !== 'undefined' && this.competitors !== null) {
      toReturn['competitors'] = 'toApiJson' in this.competitors ? this.competitors.toApiJson() : this.competitors;
    }
    return toReturn;
  }
}
class SocialDataItem {
  static fromProto(proto) {
    let m = new SocialDataItem();
    m = Object.assign(m, proto);
    if (proto.grade) {
      m.grade = enumStringToValue$a(Grade, proto.grade);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.grade !== 'undefined') {
      toReturn['grade'] = this.grade;
    }
    if (typeof this.business !== 'undefined') {
      toReturn['business'] = this.business;
    }
    if (typeof this.industryAverage !== 'undefined') {
      toReturn['industryAverage'] = this.industryAverage;
    }
    if (typeof this.industryLeader !== 'undefined') {
      toReturn['industryLeader'] = this.industryLeader;
    }
    return toReturn;
  }
}
class SocialSection {
  static fromProto(proto) {
    let m = new SocialSection();
    m = Object.assign(m, proto);
    if (proto.grade) {
      m.grade = enumStringToValue$a(Grade, proto.grade);
    }
    if (proto.content) {
      m.content = SectionContent.fromProto(proto.content);
    }
    if (proto.data) {
      m.data = SocialData.fromProto(proto.data);
    }
    if (proto.config) {
      m.config = SocialConfig.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.grade !== 'undefined') {
      toReturn['grade'] = this.grade;
    }
    if (typeof this.content !== 'undefined' && this.content !== null) {
      toReturn['content'] = 'toApiJson' in this.content ? this.content.toApiJson() : this.content;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
class SocialDataCompetitorTwitterData {
  static fromProto(proto) {
    let m = new SocialDataCompetitorTwitterData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.following !== 'undefined') {
      toReturn['following'] = this.following;
    }
    if (typeof this.followers !== 'undefined') {
      toReturn['followers'] = this.followers;
    }
    if (typeof this.tweets !== 'undefined') {
      toReturn['tweets'] = this.tweets;
    }
    return toReturn;
  }
}
class TwitterData {
  static fromProto(proto) {
    let m = new TwitterData();
    m = Object.assign(m, proto);
    if (proto.following) {
      m.following = SocialDataItem.fromProto(proto.following);
    }
    if (proto.followers) {
      m.followers = SocialDataItem.fromProto(proto.followers);
    }
    if (proto.tweets) {
      m.tweets = SocialDataItem.fromProto(proto.tweets);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.following !== 'undefined' && this.following !== null) {
      toReturn['following'] = 'toApiJson' in this.following ? this.following.toApiJson() : this.following;
    }
    if (typeof this.followers !== 'undefined' && this.followers !== null) {
      toReturn['followers'] = 'toApiJson' in this.followers ? this.followers.toApiJson() : this.followers;
    }
    if (typeof this.tweets !== 'undefined' && this.tweets !== null) {
      toReturn['tweets'] = 'toApiJson' in this.tweets ? this.tweets.toApiJson() : this.tweets;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
function enumStringToValue$9(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Audit {
  static fromProto(proto) {
    let m = new Audit();
    m = Object.assign(m, proto);
    if (proto.details) {
      m.details = proto.details.map(AuditDetail.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.score !== 'undefined') {
      toReturn['score'] = this.score;
    }
    if (typeof this.details !== 'undefined' && this.details !== null) {
      toReturn['details'] = 'toApiJson' in this.details ? this.details.toApiJson() : this.details;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class AuditDetail {
  static fromProto(proto) {
    let m = new AuditDetail();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.detailItems !== 'undefined') {
      toReturn['detailItems'] = this.detailItems;
    }
    return toReturn;
  }
}
class AuditSummary {
  static fromProto(proto) {
    let m = new AuditSummary();
    m = Object.assign(m, proto);
    if (proto.grade) {
      m.grade = enumStringToValue$9(Grade, proto.grade);
    }
    if (proto.audits) {
      m.audits = proto.audits.map(Audit.fromProto);
    }
    if (proto.score) {
      m.score = parseInt(proto.score, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.grade !== 'undefined') {
      toReturn['grade'] = this.grade;
    }
    if (typeof this.audits !== 'undefined' && this.audits !== null) {
      toReturn['audits'] = 'toApiJson' in this.audits ? this.audits.toApiJson() : this.audits;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.score !== 'undefined') {
      toReturn['score'] = this.score;
    }
    return toReturn;
  }
}
class WebsiteDataCompetitor {
  static fromProto(proto) {
    let m = new WebsiteDataCompetitor();
    m = Object.assign(m, proto);
    if (proto.homepageData) {
      m.homepageData = CompetitorHomepageData.fromProto(proto.homepageData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.homepageData !== 'undefined' && this.homepageData !== null) {
      toReturn['homepageData'] = 'toApiJson' in this.homepageData ? this.homepageData.toApiJson() : this.homepageData;
    }
    return toReturn;
  }
}
class CompetitorHomepageData {
  static fromProto(proto) {
    let m = new CompetitorHomepageData();
    m = Object.assign(m, proto);
    if (proto.size) {
      m.size = parseInt(proto.size, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.size !== 'undefined') {
      toReturn['size'] = this.size;
    }
    if (typeof this.facebookPresent !== 'undefined') {
      toReturn['facebookPresent'] = this.facebookPresent;
    }
    if (typeof this.twitterPresent !== 'undefined') {
      toReturn['twitterPresent'] = this.twitterPresent;
    }
    if (typeof this.instagramPresent !== 'undefined') {
      toReturn['instagramPresent'] = this.instagramPresent;
    }
    if (typeof this.videoPresent !== 'undefined') {
      toReturn['videoPresent'] = this.videoPresent;
    }
    return toReturn;
  }
}
class HomepageData {
  static fromProto(proto) {
    let m = new HomepageData();
    m = Object.assign(m, proto);
    if (proto.grade) {
      m.grade = enumStringToValue$9(Grade, proto.grade);
    }
    if (proto.size) {
      m.size = parseInt(proto.size, 10);
    }
    if (proto.sizeIndustryAverage) {
      m.sizeIndustryAverage = parseInt(proto.sizeIndustryAverage, 10);
    }
    if (proto.score) {
      m.score = parseInt(proto.score, 10);
    }
    if (proto.sizeIndustryPercentiles) {
      m.sizeIndustryPercentiles = IndustryPercentiles.fromProto(proto.sizeIndustryPercentiles);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.grade !== 'undefined') {
      toReturn['grade'] = this.grade;
    }
    if (typeof this.size !== 'undefined') {
      toReturn['size'] = this.size;
    }
    if (typeof this.sizeIndustryAverage !== 'undefined') {
      toReturn['sizeIndustryAverage'] = this.sizeIndustryAverage;
    }
    if (typeof this.facebookPresent !== 'undefined') {
      toReturn['facebookPresent'] = this.facebookPresent;
    }
    if (typeof this.facebookPresentIndustryAverage !== 'undefined') {
      toReturn['facebookPresentIndustryAverage'] = this.facebookPresentIndustryAverage;
    }
    if (typeof this.twitterPresent !== 'undefined') {
      toReturn['twitterPresent'] = this.twitterPresent;
    }
    if (typeof this.twitterPresentIndustryAverage !== 'undefined') {
      toReturn['twitterPresentIndustryAverage'] = this.twitterPresentIndustryAverage;
    }
    if (typeof this.addressPresent !== 'undefined') {
      toReturn['addressPresent'] = this.addressPresent;
    }
    if (typeof this.addressPresentIndustryAverage !== 'undefined') {
      toReturn['addressPresentIndustryAverage'] = this.addressPresentIndustryAverage;
    }
    if (typeof this.phonePresent !== 'undefined') {
      toReturn['phonePresent'] = this.phonePresent;
    }
    if (typeof this.phonePresentIndustryAverage !== 'undefined') {
      toReturn['phonePresentIndustryAverage'] = this.phonePresentIndustryAverage;
    }
    if (typeof this.score !== 'undefined') {
      toReturn['score'] = this.score;
    }
    if (typeof this.sizeIndustryPercentiles !== 'undefined' && this.sizeIndustryPercentiles !== null) {
      toReturn['sizeIndustryPercentiles'] = 'toApiJson' in this.sizeIndustryPercentiles ? this.sizeIndustryPercentiles.toApiJson() : this.sizeIndustryPercentiles;
    }
    if (typeof this.videoPresent !== 'undefined') {
      toReturn['videoPresent'] = this.videoPresent;
    }
    if (typeof this.videoPresentIndustryAverage !== 'undefined') {
      toReturn['videoPresentIndustryAverage'] = this.videoPresentIndustryAverage;
    }
    if (typeof this.instagramPresent !== 'undefined') {
      toReturn['instagramPresent'] = this.instagramPresent;
    }
    if (typeof this.instagramPresentIndustryAverage !== 'undefined') {
      toReturn['instagramPresentIndustryAverage'] = this.instagramPresentIndustryAverage;
    }
    return toReturn;
  }
}
class Rule {
  static fromProto(proto) {
    let m = new Rule();
    m = Object.assign(m, proto);
    if (proto.details) {
      m.details = proto.details.map(RuleDetail.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.summaryHtml !== 'undefined') {
      toReturn['summaryHtml'] = this.summaryHtml;
    }
    if (typeof this.impact !== 'undefined') {
      toReturn['impact'] = this.impact;
    }
    if (typeof this.details !== 'undefined' && this.details !== null) {
      toReturn['details'] = 'toApiJson' in this.details ? this.details.toApiJson() : this.details;
    }
    return toReturn;
  }
}
class RuleDetail {
  static fromProto(proto) {
    let m = new RuleDetail();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.titleHtml !== 'undefined') {
      toReturn['titleHtml'] = this.titleHtml;
    }
    if (typeof this.detailItems !== 'undefined') {
      toReturn['detailItems'] = this.detailItems;
    }
    return toReturn;
  }
}
class RuleSummary {
  static fromProto(proto) {
    let m = new RuleSummary();
    m = Object.assign(m, proto);
    if (proto.grade) {
      m.grade = enumStringToValue$9(Grade, proto.grade);
    }
    if (proto.rules) {
      m.rules = proto.rules.map(Rule.fromProto);
    }
    if (proto.score) {
      m.score = parseInt(proto.score, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.grade !== 'undefined') {
      toReturn['grade'] = this.grade;
    }
    if (typeof this.rules !== 'undefined' && this.rules !== null) {
      toReturn['rules'] = 'toApiJson' in this.rules ? this.rules.toApiJson() : this.rules;
    }
    if (typeof this.locale !== 'undefined') {
      toReturn['locale'] = this.locale;
    }
    if (typeof this.score !== 'undefined') {
      toReturn['score'] = this.score;
    }
    return toReturn;
  }
}
class SSLSummary {
  static fromProto(proto) {
    let m = new SSLSummary();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$9(SSLSummaryStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
class WebsiteConfig {
  static fromProto(proto) {
    let m = new WebsiteConfig();
    m = Object.assign(m, proto);
    if (proto.sectionVersion) {
      m.sectionVersion = parseInt(proto.sectionVersion, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hideContent !== 'undefined') {
      toReturn['hideContent'] = this.hideContent;
    }
    if (typeof this.customizedMessage !== 'undefined') {
      toReturn['customizedMessage'] = this.customizedMessage;
    }
    if (typeof this.hideMissingWebsiteWarning !== 'undefined') {
      toReturn['hideMissingWebsiteWarning'] = this.hideMissingWebsiteWarning;
    }
    if (typeof this.hideMobile !== 'undefined') {
      toReturn['hideMobile'] = this.hideMobile;
    }
    if (typeof this.hideMobilePreview !== 'undefined') {
      toReturn['hideMobilePreview'] = this.hideMobilePreview;
    }
    if (typeof this.hideDesktop !== 'undefined') {
      toReturn['hideDesktop'] = this.hideDesktop;
    }
    if (typeof this.hideDesktopPreview !== 'undefined') {
      toReturn['hideDesktopPreview'] = this.hideDesktopPreview;
    }
    if (typeof this.hideHomepageContent !== 'undefined') {
      toReturn['hideHomepageContent'] = this.hideHomepageContent;
    }
    if (typeof this.hideFooter !== 'undefined') {
      toReturn['hideFooter'] = this.hideFooter;
    }
    if (typeof this.hideHomepageVideo !== 'undefined') {
      toReturn['hideHomepageVideo'] = this.hideHomepageVideo;
    }
    if (typeof this.customizedFooterMessage !== 'undefined') {
      toReturn['customizedFooterMessage'] = this.customizedFooterMessage;
    }
    if (typeof this.customizedFooterCtaLabel !== 'undefined') {
      toReturn['customizedFooterCtaLabel'] = this.customizedFooterCtaLabel;
    }
    if (typeof this.customizedFooterCtaTargetUrl !== 'undefined') {
      toReturn['customizedFooterCtaTargetUrl'] = this.customizedFooterCtaTargetUrl;
    }
    if (typeof this.customizedFooterCtaTargetProduct !== 'undefined') {
      toReturn['customizedFooterCtaTargetProduct'] = this.customizedFooterCtaTargetProduct;
    }
    if (typeof this.sectionVersion !== 'undefined') {
      toReturn['sectionVersion'] = this.sectionVersion;
    }
    return toReturn;
  }
}
class WebsiteData {
  static fromProto(proto) {
    let m = new WebsiteData();
    m = Object.assign(m, proto);
    if (proto.homepageData) {
      m.homepageData = HomepageData.fromProto(proto.homepageData);
    }
    if (proto.desktopSpeed) {
      m.desktopSpeed = RuleSummary.fromProto(proto.desktopSpeed);
    }
    if (proto.mobileSpeed) {
      m.mobileSpeed = RuleSummary.fromProto(proto.mobileSpeed);
    }
    if (proto.userExperience) {
      m.userExperience = RuleSummary.fromProto(proto.userExperience);
    }
    if (proto.mobileGrade) {
      m.mobileGrade = enumStringToValue$9(Grade, proto.mobileGrade);
    }
    if (proto.desktopInsights) {
      m.desktopInsights = AuditSummary.fromProto(proto.desktopInsights);
    }
    if (proto.mobileInsights) {
      m.mobileInsights = AuditSummary.fromProto(proto.mobileInsights);
    }
    if (proto.competitors) {
      m.competitors = proto.competitors.map(WebsiteDataCompetitor.fromProto);
    }
    if (proto.ssl) {
      m.ssl = SSLSummary.fromProto(proto.ssl);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.homepageData !== 'undefined' && this.homepageData !== null) {
      toReturn['homepageData'] = 'toApiJson' in this.homepageData ? this.homepageData.toApiJson() : this.homepageData;
    }
    if (typeof this.desktopSpeed !== 'undefined' && this.desktopSpeed !== null) {
      toReturn['desktopSpeed'] = 'toApiJson' in this.desktopSpeed ? this.desktopSpeed.toApiJson() : this.desktopSpeed;
    }
    if (typeof this.mobileSpeed !== 'undefined' && this.mobileSpeed !== null) {
      toReturn['mobileSpeed'] = 'toApiJson' in this.mobileSpeed ? this.mobileSpeed.toApiJson() : this.mobileSpeed;
    }
    if (typeof this.userExperience !== 'undefined' && this.userExperience !== null) {
      toReturn['userExperience'] = 'toApiJson' in this.userExperience ? this.userExperience.toApiJson() : this.userExperience;
    }
    if (typeof this.mobileScreenshot !== 'undefined') {
      toReturn['mobileScreenshot'] = this.mobileScreenshot;
    }
    if (typeof this.desktopScreenshot !== 'undefined') {
      toReturn['desktopScreenshot'] = this.desktopScreenshot;
    }
    if (typeof this.mobileGrade !== 'undefined') {
      toReturn['mobileGrade'] = this.mobileGrade;
    }
    if (typeof this.mobileFriendly !== 'undefined') {
      toReturn['mobileFriendly'] = this.mobileFriendly;
    }
    if (typeof this.desktopInsights !== 'undefined' && this.desktopInsights !== null) {
      toReturn['desktopInsights'] = 'toApiJson' in this.desktopInsights ? this.desktopInsights.toApiJson() : this.desktopInsights;
    }
    if (typeof this.mobileInsights !== 'undefined' && this.mobileInsights !== null) {
      toReturn['mobileInsights'] = 'toApiJson' in this.mobileInsights ? this.mobileInsights.toApiJson() : this.mobileInsights;
    }
    if (typeof this.competitors !== 'undefined' && this.competitors !== null) {
      toReturn['competitors'] = 'toApiJson' in this.competitors ? this.competitors.toApiJson() : this.competitors;
    }
    if (typeof this.ssl !== 'undefined' && this.ssl !== null) {
      toReturn['ssl'] = 'toApiJson' in this.ssl ? this.ssl.toApiJson() : this.ssl;
    }
    return toReturn;
  }
}
class WebsiteSection {
  static fromProto(proto) {
    let m = new WebsiteSection();
    m = Object.assign(m, proto);
    if (proto.grade) {
      m.grade = enumStringToValue$9(Grade, proto.grade);
    }
    if (proto.content) {
      m.content = SectionContent.fromProto(proto.content);
    }
    if (proto.data) {
      m.data = WebsiteData.fromProto(proto.data);
    }
    if (proto.config) {
      m.config = WebsiteConfig.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.grade !== 'undefined') {
      toReturn['grade'] = this.grade;
    }
    if (typeof this.content !== 'undefined' && this.content !== null) {
      toReturn['content'] = 'toApiJson' in this.content ? this.content.toApiJson() : this.content;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Branding {
  static fromProto(proto) {
    let m = new Branding();
    m = Object.assign(m, proto);
    if (proto.assets) {
      m.assets = BrandingAssets.fromProto(proto.assets);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.primaryColor !== 'undefined') {
      toReturn['primaryColor'] = this.primaryColor;
    }
    if (typeof this.assets !== 'undefined' && this.assets !== null) {
      toReturn['assets'] = 'toApiJson' in this.assets ? this.assets.toApiJson() : this.assets;
    }
    if (typeof this.businessCenterName !== 'undefined') {
      toReturn['businessCenterName'] = this.businessCenterName;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.partnerName !== 'undefined') {
      toReturn['partnerName'] = this.partnerName;
    }
    if (typeof this.businessCenterHost !== 'undefined') {
      toReturn['businessCenterHost'] = this.businessCenterHost;
    }
    return toReturn;
  }
}
class BrandingAssets {
  static fromProto(proto) {
    let m = new BrandingAssets();
    m = Object.assign(m, proto);
    if (proto.faviconUrl) {
      m.faviconUrl = URL.fromProto(proto.faviconUrl);
    }
    if (proto.shortcutIconUrl) {
      m.shortcutIconUrl = URL.fromProto(proto.shortcutIconUrl);
    }
    if (proto.logoUrl) {
      m.logoUrl = URL.fromProto(proto.logoUrl);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.faviconUrl !== 'undefined' && this.faviconUrl !== null) {
      toReturn['faviconUrl'] = 'toApiJson' in this.faviconUrl ? this.faviconUrl.toApiJson() : this.faviconUrl;
    }
    if (typeof this.shortcutIconUrl !== 'undefined' && this.shortcutIconUrl !== null) {
      toReturn['shortcutIconUrl'] = 'toApiJson' in this.shortcutIconUrl ? this.shortcutIconUrl.toApiJson() : this.shortcutIconUrl;
    }
    if (typeof this.logoUrl !== 'undefined' && this.logoUrl !== null) {
      toReturn['logoUrl'] = 'toApiJson' in this.logoUrl ? this.logoUrl.toApiJson() : this.logoUrl;
    }
    return toReturn;
  }
}
class URL {
  static fromProto(proto) {
    let m = new URL();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.secure !== 'undefined') {
      toReturn['secure'] = this.secure;
    }
    if (typeof this.insecure !== 'undefined') {
      toReturn['insecure'] = this.insecure;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Application {
  static fromProto(proto) {
    let m = new Application();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    return toReturn;
  }
}
class EcommerceDataApplicationsAvailabilityEntry {
  static fromProto(proto) {
    let m = new EcommerceDataApplicationsAvailabilityEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class EcommerceDataCompetitor {
  static fromProto(proto) {
    let m = new EcommerceDataCompetitor();
    m = Object.assign(m, proto);
    if (proto.ecommerceSolution) {
      m.ecommerceSolution = proto.ecommerceSolution.map(Application.fromProto);
    }
    if (proto.onlinePayments) {
      m.onlinePayments = proto.onlinePayments.map(Application.fromProto);
    }
    if (proto.adRetargeting) {
      m.adRetargeting = proto.adRetargeting.map(Application.fromProto);
    }
    if (proto.appointmentScheduling) {
      m.appointmentScheduling = proto.appointmentScheduling.map(Application.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.ecommerceSolution !== 'undefined' && this.ecommerceSolution !== null) {
      toReturn['ecommerceSolution'] = 'toApiJson' in this.ecommerceSolution ? this.ecommerceSolution.toApiJson() : this.ecommerceSolution;
    }
    if (typeof this.onlinePayments !== 'undefined' && this.onlinePayments !== null) {
      toReturn['onlinePayments'] = 'toApiJson' in this.onlinePayments ? this.onlinePayments.toApiJson() : this.onlinePayments;
    }
    if (typeof this.adRetargeting !== 'undefined' && this.adRetargeting !== null) {
      toReturn['adRetargeting'] = 'toApiJson' in this.adRetargeting ? this.adRetargeting.toApiJson() : this.adRetargeting;
    }
    if (typeof this.appointmentScheduling !== 'undefined' && this.appointmentScheduling !== null) {
      toReturn['appointmentScheduling'] = 'toApiJson' in this.appointmentScheduling ? this.appointmentScheduling.toApiJson() : this.appointmentScheduling;
    }
    return toReturn;
  }
}
class EcommerceConfig {
  static fromProto(proto) {
    let m = new EcommerceConfig();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hideContent !== 'undefined') {
      toReturn['hideContent'] = this.hideContent;
    }
    if (typeof this.customizedMessage !== 'undefined') {
      toReturn['customizedMessage'] = this.customizedMessage;
    }
    if (typeof this.hideFooter !== 'undefined') {
      toReturn['hideFooter'] = this.hideFooter;
    }
    if (typeof this.hideEcommerceSolution !== 'undefined') {
      toReturn['hideEcommerceSolution'] = this.hideEcommerceSolution;
    }
    if (typeof this.hideOnlinePayments !== 'undefined') {
      toReturn['hideOnlinePayments'] = this.hideOnlinePayments;
    }
    if (typeof this.hideDigitalAdvertising !== 'undefined') {
      toReturn['hideDigitalAdvertising'] = this.hideDigitalAdvertising;
    }
    if (typeof this.hideAdRetargeting !== 'undefined') {
      toReturn['hideAdRetargeting'] = this.hideAdRetargeting;
    }
    if (typeof this.customizedFooterMessage !== 'undefined') {
      toReturn['customizedFooterMessage'] = this.customizedFooterMessage;
    }
    if (typeof this.customizedFooterCtaLabel !== 'undefined') {
      toReturn['customizedFooterCtaLabel'] = this.customizedFooterCtaLabel;
    }
    if (typeof this.customizedFooterCtaTargetUrl !== 'undefined') {
      toReturn['customizedFooterCtaTargetUrl'] = this.customizedFooterCtaTargetUrl;
    }
    if (typeof this.customizedFooterCtaTargetProduct !== 'undefined') {
      toReturn['customizedFooterCtaTargetProduct'] = this.customizedFooterCtaTargetProduct;
    }
    if (typeof this.hideAppointmentScheduling !== 'undefined') {
      toReturn['hideAppointmentScheduling'] = this.hideAppointmentScheduling;
    }
    return toReturn;
  }
}
class EcommerceData {
  static fromProto(proto) {
    let m = new EcommerceData();
    m = Object.assign(m, proto);
    if (proto.grade) {
      m.grade = enumStringToValue$7(Grade, proto.grade);
    }
    if (proto.ecommerceSolution) {
      m.ecommerceSolution = proto.ecommerceSolution.map(Application.fromProto);
    }
    if (proto.onlinePayments) {
      m.onlinePayments = proto.onlinePayments.map(Application.fromProto);
    }
    if (proto.digitalAdvertising) {
      m.digitalAdvertising = proto.digitalAdvertising.map(Application.fromProto);
    }
    if (proto.adRetargeting) {
      m.adRetargeting = proto.adRetargeting.map(Application.fromProto);
    }
    if (proto.competitors) {
      m.competitors = proto.competitors.map(EcommerceDataCompetitor.fromProto);
    }
    if (proto.appointmentScheduling) {
      m.appointmentScheduling = proto.appointmentScheduling.map(Application.fromProto);
    }
    if (proto.applicationsAvailability) {
      m.applicationsAvailability = Object.keys(proto.applicationsAvailability).reduce((obj, k) => {
        obj[k] = proto.applicationsAvailability[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.grade !== 'undefined') {
      toReturn['grade'] = this.grade;
    }
    if (typeof this.ecommerceSolution !== 'undefined' && this.ecommerceSolution !== null) {
      toReturn['ecommerceSolution'] = 'toApiJson' in this.ecommerceSolution ? this.ecommerceSolution.toApiJson() : this.ecommerceSolution;
    }
    if (typeof this.onlinePayments !== 'undefined' && this.onlinePayments !== null) {
      toReturn['onlinePayments'] = 'toApiJson' in this.onlinePayments ? this.onlinePayments.toApiJson() : this.onlinePayments;
    }
    if (typeof this.digitalAdvertising !== 'undefined' && this.digitalAdvertising !== null) {
      toReturn['digitalAdvertising'] = 'toApiJson' in this.digitalAdvertising ? this.digitalAdvertising.toApiJson() : this.digitalAdvertising;
    }
    if (typeof this.adRetargeting !== 'undefined' && this.adRetargeting !== null) {
      toReturn['adRetargeting'] = 'toApiJson' in this.adRetargeting ? this.adRetargeting.toApiJson() : this.adRetargeting;
    }
    if (typeof this.competitors !== 'undefined' && this.competitors !== null) {
      toReturn['competitors'] = 'toApiJson' in this.competitors ? this.competitors.toApiJson() : this.competitors;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.appointmentScheduling !== 'undefined' && this.appointmentScheduling !== null) {
      toReturn['appointmentScheduling'] = 'toApiJson' in this.appointmentScheduling ? this.appointmentScheduling.toApiJson() : this.appointmentScheduling;
    }
    if (typeof this.applicationsAvailability !== 'undefined' && this.applicationsAvailability !== null) {
      toReturn['applicationsAvailability'] = 'toApiJson' in this.applicationsAvailability ? this.applicationsAvailability.toApiJson() : this.applicationsAvailability;
    }
    return toReturn;
  }
}
class EcommerceSection {
  static fromProto(proto) {
    let m = new EcommerceSection();
    m = Object.assign(m, proto);
    if (proto.grade) {
      m.grade = enumStringToValue$7(Grade, proto.grade);
    }
    if (proto.content) {
      m.content = SectionContent.fromProto(proto.content);
    }
    if (proto.data) {
      m.data = EcommerceData.fromProto(proto.data);
    }
    if (proto.config) {
      m.config = EcommerceConfig.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.grade !== 'undefined') {
      toReturn['grade'] = this.grade;
    }
    if (typeof this.content !== 'undefined' && this.content !== null) {
      toReturn['content'] = 'toApiJson' in this.content ? this.content.toApiJson() : this.content;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class DirectCompetitor {
  static fromProto(proto) {
    let m = new DirectCompetitor();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Record {
  static fromProto(proto) {
    let m = new Record();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.expired) {
      m.expired = new Date(proto.expired);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.expired !== 'undefined' && this.expired !== null) {
      toReturn['expired'] = 'toApiJson' in this.expired ? this.expired.toApiJson() : this.expired;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.createdBy !== 'undefined') {
      toReturn['createdBy'] = this.createdBy;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Technology {
  static fromProto(proto) {
    let m = new Technology();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.technologyId !== 'undefined') {
      toReturn['technologyId'] = this.technologyId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.categoryIds !== 'undefined') {
      toReturn['categoryIds'] = this.categoryIds;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.iconName !== 'undefined') {
      toReturn['iconName'] = this.iconName;
    }
    return toReturn;
  }
}
class TechnologyCategory {
  static fromProto(proto) {
    let m = new TechnologyCategory();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categoryId !== 'undefined') {
      toReturn['categoryId'] = this.categoryId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class TechnologyConfig {
  static fromProto(proto) {
    let m = new TechnologyConfig();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hideContent !== 'undefined') {
      toReturn['hideContent'] = this.hideContent;
    }
    if (typeof this.customizedMessage !== 'undefined') {
      toReturn['customizedMessage'] = this.customizedMessage;
    }
    if (typeof this.hideFooter !== 'undefined') {
      toReturn['hideFooter'] = this.hideFooter;
    }
    if (typeof this.customizedFooterMessage !== 'undefined') {
      toReturn['customizedFooterMessage'] = this.customizedFooterMessage;
    }
    if (typeof this.customizedFooterCtaLabel !== 'undefined') {
      toReturn['customizedFooterCtaLabel'] = this.customizedFooterCtaLabel;
    }
    if (typeof this.customizedFooterCtaTargetUrl !== 'undefined') {
      toReturn['customizedFooterCtaTargetUrl'] = this.customizedFooterCtaTargetUrl;
    }
    if (typeof this.customizedFooterCtaTargetProduct !== 'undefined') {
      toReturn['customizedFooterCtaTargetProduct'] = this.customizedFooterCtaTargetProduct;
    }
    return toReturn;
  }
}
class TechnologyData {
  static fromProto(proto) {
    let m = new TechnologyData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.technologyIds !== 'undefined') {
      toReturn['technologyIds'] = this.technologyIds;
    }
    return toReturn;
  }
}
class TechnologySection {
  static fromProto(proto) {
    let m = new TechnologySection();
    m = Object.assign(m, proto);
    if (proto.grade) {
      m.grade = enumStringToValue$3(Grade, proto.grade);
    }
    if (proto.content) {
      m.content = SectionContent.fromProto(proto.content);
    }
    if (proto.data) {
      m.data = TechnologyData.fromProto(proto.data);
    }
    if (proto.config) {
      m.config = TechnologyConfig.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.grade !== 'undefined') {
      toReturn['grade'] = this.grade;
    }
    if (typeof this.content !== 'undefined' && this.content !== null) {
      toReturn['content'] = 'toApiJson' in this.content ? this.content.toApiJson() : this.content;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
class MCPOptions {
  static fromProto(proto) {
    let m = new MCPOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serverId !== 'undefined') {
      toReturn['serverId'] = this.serverId;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AIPrompt {
  static fromProto(proto) {
    let m = new AIPrompt();
    m = Object.assign(m, proto);
    if (proto.role) {
      m.role = enumStringToValue$1(Role, proto.role);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prompt !== 'undefined') {
      toReturn['prompt'] = this.prompt;
    }
    if (typeof this.role !== 'undefined') {
      toReturn['role'] = this.role;
    }
    return toReturn;
  }
}
class ContextualizeRequest {
  static fromProto(proto) {
    let m = new ContextualizeRequest();
    m = Object.assign(m, proto);
    if (proto.sections) {
      m.sections = proto.sections.map(v => enumStringToValue$1(Section, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.sections !== 'undefined') {
      toReturn['sections'] = this.sections;
    }
    return toReturn;
  }
}
class ContextualizeResponse {
  static fromProto(proto) {
    let m = new ContextualizeResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    return toReturn;
  }
}
class GetWidgetRequest {
  static fromProto(proto) {
    let m = new GetWidgetRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    return toReturn;
  }
}
class GetWidgetResponse {
  static fromProto(proto) {
    let m = new GetWidgetResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.widgetId !== 'undefined') {
      toReturn['widgetId'] = this.widgetId;
    }
    if (typeof this.widgetUrl !== 'undefined') {
      toReturn['widgetUrl'] = this.widgetUrl;
    }
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CanProvisionSnapshotRequest {
  static fromProto(proto) {
    let m = new CanProvisionSnapshotRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class CanProvisionSnapshotResponse {
  static fromProto(proto) {
    let m = new CanProvisionSnapshotResponse();
    m = Object.assign(m, proto);
    if (proto.reason) {
      m.reason = proto.reason.map(v => enumStringToValue(CannotProvisionReason, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.canProvision !== 'undefined') {
      toReturn['canProvision'] = this.canProvision;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    return toReturn;
  }
}
class CreateSnapshotRequest {
  static fromProto(proto) {
    let m = new CreateSnapshotRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.createdBy !== 'undefined') {
      toReturn['createdBy'] = this.createdBy;
    }
    return toReturn;
  }
}
class CreateSnapshotResponse {
  static fromProto(proto) {
    let m = new CreateSnapshotResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    return toReturn;
  }
}
class CreateTechnologyRequest {
  static fromProto(proto) {
    let m = new CreateTechnologyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.categoryIds !== 'undefined') {
      toReturn['categoryIds'] = this.categoryIds;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.iconName !== 'undefined') {
      toReturn['iconName'] = this.iconName;
    }
    return toReturn;
  }
}
class CreateTechnologyResponse {
  static fromProto(proto) {
    let m = new CreateTechnologyResponse();
    m = Object.assign(m, proto);
    if (proto.technology) {
      m.technology = Technology.fromProto(proto.technology);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.technology !== 'undefined' && this.technology !== null) {
      toReturn['technology'] = 'toApiJson' in this.technology ? this.technology.toApiJson() : this.technology;
    }
    return toReturn;
  }
}
class DeleteTechnologyRequest {
  static fromProto(proto) {
    let m = new DeleteTechnologyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.technologyId !== 'undefined') {
      toReturn['technologyId'] = this.technologyId;
    }
    return toReturn;
  }
}
class Domain {
  static fromProto(proto) {
    let m = new Domain();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.secure !== 'undefined') {
      toReturn['secure'] = this.secure;
    }
    return toReturn;
  }
}
class ForceRefreshSectionRequest {
  static fromProto(proto) {
    let m = new ForceRefreshSectionRequest();
    m = Object.assign(m, proto);
    if (proto.sections) {
      m.sections = proto.sections.map(v => enumStringToValue(Section, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.sections !== 'undefined') {
      toReturn['sections'] = this.sections;
    }
    return toReturn;
  }
}
class GenerateMessageRequest {
  static fromProto(proto) {
    let m = new GenerateMessageRequest();
    m = Object.assign(m, proto);
    if (proto.prompts) {
      m.prompts = proto.prompts.map(AIPrompt.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.prompts !== 'undefined' && this.prompts !== null) {
      toReturn['prompts'] = 'toApiJson' in this.prompts ? this.prompts.toApiJson() : this.prompts;
    }
    return toReturn;
  }
}
class GenerateMessageResponse {
  static fromProto(proto) {
    let m = new GenerateMessageResponse();
    m = Object.assign(m, proto);
    if (proto.role) {
      m.role = enumStringToValue(Role, proto.role);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.role !== 'undefined') {
      toReturn['role'] = this.role;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    return toReturn;
  }
}
class GeneratePDFRequest {
  static fromProto(proto) {
    let m = new GeneratePDFRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    return toReturn;
  }
}
class GeneratePDFResponse {
  static fromProto(proto) {
    let m = new GeneratePDFResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pdf !== 'undefined') {
      toReturn['pdf'] = this.pdf;
    }
    return toReturn;
  }
}
class GetAdvertisingSectionResponse {
  static fromProto(proto) {
    let m = new GetAdvertisingSectionResponse();
    m = Object.assign(m, proto);
    if (proto.section) {
      m.section = AdvertisingSection.fromProto(proto.section);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.section !== 'undefined' && this.section !== null) {
      toReturn['section'] = 'toApiJson' in this.section ? this.section.toApiJson() : this.section;
    }
    return toReturn;
  }
}
class GetAvailableListingSourcesRequest {
  static fromProto(proto) {
    let m = new GetAvailableListingSourcesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    return toReturn;
  }
}
class GetAvailableListingSourcesResponse {
  static fromProto(proto) {
    let m = new GetAvailableListingSourcesResponse();
    m = Object.assign(m, proto);
    if (proto.sources) {
      m.sources = proto.sources.map(AvailableListingSource.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sources !== 'undefined' && this.sources !== null) {
      toReturn['sources'] = 'toApiJson' in this.sources ? this.sources.toApiJson() : this.sources;
    }
    return toReturn;
  }
}
class GetBusinessIDFromSalesforceIDRequest {
  static fromProto(proto) {
    let m = new GetBusinessIDFromSalesforceIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesforceId !== 'undefined') {
      toReturn['salesforceId'] = this.salesforceId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetBusinessIDFromSalesforceIDResponse {
  static fromProto(proto) {
    let m = new GetBusinessIDFromSalesforceIDResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetConfigurationRequest {
  static fromProto(proto) {
    let m = new GetConfigurationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    return toReturn;
  }
}
class GetConfigurationResponse {
  static fromProto(proto) {
    let m = new GetConfigurationResponse();
    m = Object.assign(m, proto);
    if (proto.configuration) {
      m.configuration = Configuration.fromProto(proto.configuration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configuration !== 'undefined' && this.configuration !== null) {
      toReturn['configuration'] = 'toApiJson' in this.configuration ? this.configuration.toApiJson() : this.configuration;
    }
    return toReturn;
  }
}
class GetCurrentRequest {
  static fromProto(proto) {
    let m = new GetCurrentRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetCurrentResponse {
  static fromProto(proto) {
    let m = new GetCurrentResponse();
    m = Object.assign(m, proto);
    if (proto.snapshot) {
      m.snapshot = Current.fromProto(proto.snapshot);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshot !== 'undefined' && this.snapshot !== null) {
      toReturn['snapshot'] = 'toApiJson' in this.snapshot ? this.snapshot.toApiJson() : this.snapshot;
    }
    return toReturn;
  }
}
class GetDirectCompetitorsRequest {
  static fromProto(proto) {
    let m = new GetDirectCompetitorsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    return toReturn;
  }
}
class GetDirectCompetitorsResponse {
  static fromProto(proto) {
    let m = new GetDirectCompetitorsResponse();
    m = Object.assign(m, proto);
    if (proto.directCompetitors) {
      m.directCompetitors = proto.directCompetitors.map(DirectCompetitor.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.directCompetitors !== 'undefined' && this.directCompetitors !== null) {
      toReturn['directCompetitors'] = 'toApiJson' in this.directCompetitors ? this.directCompetitors.toApiJson() : this.directCompetitors;
    }
    return toReturn;
  }
}
class GetDomainRequest {
  static fromProto(proto) {
    let m = new GetDomainRequest();
    m = Object.assign(m, proto);
    if (proto.application) {
      m.application = enumStringToValue(AppDomain, proto.application);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.application !== 'undefined') {
      toReturn['application'] = this.application;
    }
    return toReturn;
  }
}
class GetDomainResponse {
  static fromProto(proto) {
    let m = new GetDomainResponse();
    m = Object.assign(m, proto);
    if (proto.primary) {
      m.primary = Domain.fromProto(proto.primary);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.primary !== 'undefined' && this.primary !== null) {
      toReturn['primary'] = 'toApiJson' in this.primary ? this.primary.toApiJson() : this.primary;
    }
    return toReturn;
  }
}
class GetEcommerceSectionResponse {
  static fromProto(proto) {
    let m = new GetEcommerceSectionResponse();
    m = Object.assign(m, proto);
    if (proto.section) {
      m.section = EcommerceSection.fromProto(proto.section);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.section !== 'undefined' && this.section !== null) {
      toReturn['section'] = 'toApiJson' in this.section ? this.section.toApiJson() : this.section;
    }
    return toReturn;
  }
}
class GetFreeSnapshotsRemainingRequest {
  static fromProto(proto) {
    let m = new GetFreeSnapshotsRemainingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class GetFreeSnapshotsRemainingResponse {
  static fromProto(proto) {
    let m = new GetFreeSnapshotsRemainingResponse();
    m = Object.assign(m, proto);
    if (proto.freeSnapshotsRemaining) {
      m.freeSnapshotsRemaining = parseInt(proto.freeSnapshotsRemaining, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.freeSnapshotsRemaining !== 'undefined') {
      toReturn['freeSnapshotsRemaining'] = this.freeSnapshotsRemaining;
    }
    return toReturn;
  }
}
class GetLatestSnapshotIDRequest {
  static fromProto(proto) {
    let m = new GetLatestSnapshotIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetLatestSnapshotIDResponse {
  static fromProto(proto) {
    let m = new GetLatestSnapshotIDResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    return toReturn;
  }
}
class GetListingScanRequest {
  static fromProto(proto) {
    let m = new GetListingScanRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetListingScanResponse {
  static fromProto(proto) {
    let m = new GetListingScanResponse();
    m = Object.assign(m, proto);
    if (proto.listingScan) {
      m.listingScan = ListingScan.fromProto(proto.listingScan);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listingScan !== 'undefined' && this.listingScan !== null) {
      toReturn['listingScan'] = 'toApiJson' in this.listingScan ? this.listingScan.toApiJson() : this.listingScan;
    }
    return toReturn;
  }
}
class GetListingSectionResponse {
  static fromProto(proto) {
    let m = new GetListingSectionResponse();
    m = Object.assign(m, proto);
    if (proto.section) {
      m.section = ListingSection.fromProto(proto.section);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.section !== 'undefined' && this.section !== null) {
      toReturn['section'] = 'toApiJson' in this.section ? this.section.toApiJson() : this.section;
    }
    return toReturn;
  }
}
class GetMultiTechnologyCategoryRequest {
  static fromProto(proto) {
    let m = new GetMultiTechnologyCategoryRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categoryIds !== 'undefined') {
      toReturn['categoryIds'] = this.categoryIds;
    }
    return toReturn;
  }
}
class GetMultiTechnologyCategoryResponse {
  static fromProto(proto) {
    let m = new GetMultiTechnologyCategoryResponse();
    m = Object.assign(m, proto);
    if (proto.technologyCategories) {
      m.technologyCategories = proto.technologyCategories.map(TechnologyCategory.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.technologyCategories !== 'undefined' && this.technologyCategories !== null) {
      toReturn['technologyCategories'] = 'toApiJson' in this.technologyCategories ? this.technologyCategories.toApiJson() : this.technologyCategories;
    }
    return toReturn;
  }
}
class GetMultiTechnologyRequest {
  static fromProto(proto) {
    let m = new GetMultiTechnologyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.technologyIds !== 'undefined') {
      toReturn['technologyIds'] = this.technologyIds;
    }
    return toReturn;
  }
}
class GetMultiTechnologyResponse {
  static fromProto(proto) {
    let m = new GetMultiTechnologyResponse();
    m = Object.assign(m, proto);
    if (proto.technologies) {
      m.technologies = proto.technologies.map(Technology.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.technologies !== 'undefined' && this.technologies !== null) {
      toReturn['technologies'] = 'toApiJson' in this.technologies ? this.technologies.toApiJson() : this.technologies;
    }
    return toReturn;
  }
}
class GetRequest {
  static fromProto(proto) {
    let m = new GetRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    return toReturn;
  }
}
class GetResponse {
  static fromProto(proto) {
    let m = new GetResponse();
    m = Object.assign(m, proto);
    if (proto.record) {
      m.record = Record.fromProto(proto.record);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.record !== 'undefined' && this.record !== null) {
      toReturn['record'] = 'toApiJson' in this.record ? this.record.toApiJson() : this.record;
    }
    return toReturn;
  }
}
class GetReviewSectionResponse {
  static fromProto(proto) {
    let m = new GetReviewSectionResponse();
    m = Object.assign(m, proto);
    if (proto.section) {
      m.section = ReviewSection.fromProto(proto.section);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.section !== 'undefined' && this.section !== null) {
      toReturn['section'] = 'toApiJson' in this.section ? this.section.toApiJson() : this.section;
    }
    return toReturn;
  }
}
class GetSEOSectionResponse {
  static fromProto(proto) {
    let m = new GetSEOSectionResponse();
    m = Object.assign(m, proto);
    if (proto.section) {
      m.section = SEOSection.fromProto(proto.section);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.section !== 'undefined' && this.section !== null) {
      toReturn['section'] = 'toApiJson' in this.section ? this.section.toApiJson() : this.section;
    }
    return toReturn;
  }
}
class GetSalesPersonRequest {
  static fromProto(proto) {
    let m = new GetSalesPersonRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    return toReturn;
  }
}
class GetSalesPersonResponse {
  static fromProto(proto) {
    let m = new GetSalesPersonResponse();
    m = Object.assign(m, proto);
    if (proto.salesPerson) {
      m.salesPerson = SalesPerson.fromProto(proto.salesPerson);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesPerson !== 'undefined' && this.salesPerson !== null) {
      toReturn['salesPerson'] = 'toApiJson' in this.salesPerson ? this.salesPerson.toApiJson() : this.salesPerson;
    }
    return toReturn;
  }
}
class GetSectionAvailabilityRequest {
  static fromProto(proto) {
    let m = new GetSectionAvailabilityRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    return toReturn;
  }
}
class GetSectionAvailabilityResponse {
  static fromProto(proto) {
    let m = new GetSectionAvailabilityResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isAvailable !== 'undefined') {
      toReturn['isAvailable'] = this.isAvailable;
    }
    return toReturn;
  }
}
class GetSectionRequest {
  static fromProto(proto) {
    let m = new GetSectionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    return toReturn;
  }
}
class GetSnapshotCountCreatedBySalespersonIDRequest {
  static fromProto(proto) {
    let m = new GetSnapshotCountCreatedBySalespersonIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    return toReturn;
  }
}
class GetSnapshotCountCreatedBySalespersonIDResponse {
  static fromProto(proto) {
    let m = new GetSnapshotCountCreatedBySalespersonIDResponse();
    m = Object.assign(m, proto);
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    return toReturn;
  }
}
class GetSnapshotIDRequest {
  static fromProto(proto) {
    let m = new GetSnapshotIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetSnapshotIDResponse {
  static fromProto(proto) {
    let m = new GetSnapshotIDResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    return toReturn;
  }
}
class GetSnapshotLiteRequest {
  static fromProto(proto) {
    let m = new GetSnapshotLiteRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetSnapshotLiteResponse {
  static fromProto(proto) {
    let m = new GetSnapshotLiteResponse();
    m = Object.assign(m, proto);
    if (proto.snapshot) {
      m.snapshot = SnapshotLite.fromProto(proto.snapshot);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshot !== 'undefined' && this.snapshot !== null) {
      toReturn['snapshot'] = 'toApiJson' in this.snapshot ? this.snapshot.toApiJson() : this.snapshot;
    }
    return toReturn;
  }
}
class GetSnapshotRequest {
  static fromProto(proto) {
    let m = new GetSnapshotRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    return toReturn;
  }
}
class GetSnapshotResponse {
  static fromProto(proto) {
    let m = new GetSnapshotResponse();
    m = Object.assign(m, proto);
    if (proto.snapshot) {
      m.snapshot = Snapshot.fromProto(proto.snapshot);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshot !== 'undefined' && this.snapshot !== null) {
      toReturn['snapshot'] = 'toApiJson' in this.snapshot ? this.snapshot.toApiJson() : this.snapshot;
    }
    return toReturn;
  }
}
class GetSocialSectionResponse {
  static fromProto(proto) {
    let m = new GetSocialSectionResponse();
    m = Object.assign(m, proto);
    if (proto.section) {
      m.section = SocialSection.fromProto(proto.section);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.section !== 'undefined' && this.section !== null) {
      toReturn['section'] = 'toApiJson' in this.section ? this.section.toApiJson() : this.section;
    }
    return toReturn;
  }
}
class GetSummaryRequest {
  static fromProto(proto) {
    let m = new GetSummaryRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    return toReturn;
  }
}
class GetSummaryResponse {
  static fromProto(proto) {
    let m = new GetSummaryResponse();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.expired) {
      m.expired = new Date(proto.expired);
    }
    if (proto.sections) {
      m.sections = proto.sections.map(SectionSummary.fromProto);
    }
    if (proto.location) {
      m.location = Location.fromProto(proto.location);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.expired !== 'undefined' && this.expired !== null) {
      toReturn['expired'] = 'toApiJson' in this.expired ? this.expired.toApiJson() : this.expired;
    }
    if (typeof this.score !== 'undefined') {
      toReturn['score'] = this.score;
    }
    if (typeof this.sections !== 'undefined' && this.sections !== null) {
      toReturn['sections'] = 'toApiJson' in this.sections ? this.sections.toApiJson() : this.sections;
    }
    if (typeof this.location !== 'undefined' && this.location !== null) {
      toReturn['location'] = 'toApiJson' in this.location ? this.location.toApiJson() : this.location;
    }
    return toReturn;
  }
}
class GetTechnologyRequest {
  static fromProto(proto) {
    let m = new GetTechnologyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.technologyId !== 'undefined') {
      toReturn['technologyId'] = this.technologyId;
    }
    return toReturn;
  }
}
class GetTechnologyResponse {
  static fromProto(proto) {
    let m = new GetTechnologyResponse();
    m = Object.assign(m, proto);
    if (proto.technology) {
      m.technology = Technology.fromProto(proto.technology);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.technology !== 'undefined' && this.technology !== null) {
      toReturn['technology'] = 'toApiJson' in this.technology ? this.technology.toApiJson() : this.technology;
    }
    return toReturn;
  }
}
class GetTechnologySectionResponse {
  static fromProto(proto) {
    let m = new GetTechnologySectionResponse();
    m = Object.assign(m, proto);
    if (proto.section) {
      m.section = TechnologySection.fromProto(proto.section);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.section !== 'undefined' && this.section !== null) {
      toReturn['section'] = 'toApiJson' in this.section ? this.section.toApiJson() : this.section;
    }
    return toReturn;
  }
}
class GetWebsiteSectionResponse {
  static fromProto(proto) {
    let m = new GetWebsiteSectionResponse();
    m = Object.assign(m, proto);
    if (proto.section) {
      m.section = WebsiteSection.fromProto(proto.section);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.section !== 'undefined' && this.section !== null) {
      toReturn['section'] = 'toApiJson' in this.section ? this.section.toApiJson() : this.section;
    }
    return toReturn;
  }
}
class GetWhitelabelRequest {
  static fromProto(proto) {
    let m = new GetWhitelabelRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    return toReturn;
  }
}
class GetWhitelabelResponse {
  static fromProto(proto) {
    let m = new GetWhitelabelResponse();
    m = Object.assign(m, proto);
    if (proto.branding) {
      m.branding = Branding.fromProto(proto.branding);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.branding !== 'undefined' && this.branding !== null) {
      toReturn['branding'] = 'toApiJson' in this.branding ? this.branding.toApiJson() : this.branding;
    }
    return toReturn;
  }
}
class IgnoreListingSourceRequest {
  static fromProto(proto) {
    let m = new IgnoreListingSourceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    return toReturn;
  }
}
class Location {
  static fromProto(proto) {
    let m = new Location();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    return toReturn;
  }
}
class LookupRequest {
  static fromProto(proto) {
    let m = new LookupRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class LookupResponse {
  static fromProto(proto) {
    let m = new LookupResponse();
    m = Object.assign(m, proto);
    if (proto.record) {
      m.record = proto.record.map(Record.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.record !== 'undefined' && this.record !== null) {
      toReturn['record'] = 'toApiJson' in this.record ? this.record.toApiJson() : this.record;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class PreviewEmailRequest {
  static fromProto(proto) {
    let m = new PreviewEmailRequest();
    m = Object.assign(m, proto);
    if (proto.email) {
      m.email = Email.fromProto(proto.email);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined' && this.email !== null) {
      toReturn['email'] = 'toApiJson' in this.email ? this.email.toApiJson() : this.email;
    }
    return toReturn;
  }
}
class PreviewEmailResponse {
  static fromProto(proto) {
    let m = new PreviewEmailResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.renderedTemplate !== 'undefined') {
      toReturn['renderedTemplate'] = this.renderedTemplate;
    }
    return toReturn;
  }
}
class PreviewRefreshSnapshotForBusinessesRequest {
  static fromProto(proto) {
    let m = new PreviewRefreshSnapshotForBusinessesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessIds !== 'undefined') {
      toReturn['businessIds'] = this.businessIds;
    }
    return toReturn;
  }
}
class PreviewRefreshSnapshotForBusinessesResponse {
  static fromProto(proto) {
    let m = new PreviewRefreshSnapshotForBusinessesResponse();
    m = Object.assign(m, proto);
    if (proto.total) {
      m.total = parseInt(proto.total, 10);
    }
    if (proto.toRefresh) {
      m.toRefresh = parseInt(proto.toRefresh, 10);
    }
    if (proto.toCreate) {
      m.toCreate = parseInt(proto.toCreate, 10);
    }
    if (proto.unaffected) {
      m.unaffected = parseInt(proto.unaffected, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    if (typeof this.toRefresh !== 'undefined') {
      toReturn['toRefresh'] = this.toRefresh;
    }
    if (typeof this.toCreate !== 'undefined') {
      toReturn['toCreate'] = this.toCreate;
    }
    if (typeof this.unaffected !== 'undefined') {
      toReturn['unaffected'] = this.unaffected;
    }
    return toReturn;
  }
}
class ProvisionSnapshotOptions {
  static fromProto(proto) {
    let m = new ProvisionSnapshotOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.inferMissingData !== 'undefined') {
      toReturn['inferMissingData'] = this.inferMissingData;
    }
    return toReturn;
  }
}
class ProvisionSnapshotRequest {
  static fromProto(proto) {
    let m = new ProvisionSnapshotRequest();
    m = Object.assign(m, proto);
    if (proto.options) {
      m.options = ProvisionSnapshotOptions.fromProto(proto.options);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    return toReturn;
  }
}
class ProvisionSnapshotResponse {
  static fromProto(proto) {
    let m = new ProvisionSnapshotResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    return toReturn;
  }
}
class SaveDirectCompetitorsRequest {
  static fromProto(proto) {
    let m = new SaveDirectCompetitorsRequest();
    m = Object.assign(m, proto);
    if (proto.directCompetitors) {
      m.directCompetitors = proto.directCompetitors.map(DirectCompetitor.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.directCompetitors !== 'undefined' && this.directCompetitors !== null) {
      toReturn['directCompetitors'] = 'toApiJson' in this.directCompetitors ? this.directCompetitors.toApiJson() : this.directCompetitors;
    }
    return toReturn;
  }
}
class SectionSummary {
  static fromProto(proto) {
    let m = new SectionSummary();
    m = Object.assign(m, proto);
    if (proto.grade) {
      m.grade = enumStringToValue(Grade, proto.grade);
    }
    if (proto.sectionId) {
      m.sectionId = enumStringToValue(Section, proto.sectionId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sectionName !== 'undefined') {
      toReturn['sectionName'] = this.sectionName;
    }
    if (typeof this.grade !== 'undefined') {
      toReturn['grade'] = this.grade;
    }
    if (typeof this.sectionId !== 'undefined') {
      toReturn['sectionId'] = this.sectionId;
    }
    return toReturn;
  }
}
class ShareSnapshotRequest {
  static fromProto(proto) {
    let m = new ShareSnapshotRequest();
    m = Object.assign(m, proto);
    if (proto.contacts) {
      m.contacts = proto.contacts.map(Contact.fromProto);
    }
    if (proto.sender) {
      m.sender = Contact.fromProto(proto.sender);
    }
    if (proto.email) {
      m.email = Email.fromProto(proto.email);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contacts !== 'undefined' && this.contacts !== null) {
      toReturn['contacts'] = 'toApiJson' in this.contacts ? this.contacts.toApiJson() : this.contacts;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.email !== 'undefined' && this.email !== null) {
      toReturn['email'] = 'toApiJson' in this.email ? this.email.toApiJson() : this.email;
    }
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    return toReturn;
  }
}
class UnignoreListingSourceRequest {
  static fromProto(proto) {
    let m = new UnignoreListingSourceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    return toReturn;
  }
}
class UpdateAdvertisingConfigRequest {
  static fromProto(proto) {
    let m = new UpdateAdvertisingConfigRequest();
    m = Object.assign(m, proto);
    if (proto.advertisingConfig) {
      m.advertisingConfig = AdvertisingConfig.fromProto(proto.advertisingConfig);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.advertisingConfig !== 'undefined' && this.advertisingConfig !== null) {
      toReturn['advertisingConfig'] = 'toApiJson' in this.advertisingConfig ? this.advertisingConfig.toApiJson() : this.advertisingConfig;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateCurrentRequest {
  static fromProto(proto) {
    let m = new UpdateCurrentRequest();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.expired) {
      m.expired = new Date(proto.expired);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.expired !== 'undefined' && this.expired !== null) {
      toReturn['expired'] = 'toApiJson' in this.expired ? this.expired.toApiJson() : this.expired;
    }
    return toReturn;
  }
}
class UpdateEcommerceConfigRequest {
  static fromProto(proto) {
    let m = new UpdateEcommerceConfigRequest();
    m = Object.assign(m, proto);
    if (proto.ecommerceConfig) {
      m.ecommerceConfig = EcommerceConfig.fromProto(proto.ecommerceConfig);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.ecommerceConfig !== 'undefined' && this.ecommerceConfig !== null) {
      toReturn['ecommerceConfig'] = 'toApiJson' in this.ecommerceConfig ? this.ecommerceConfig.toApiJson() : this.ecommerceConfig;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateListingConfigRequest {
  static fromProto(proto) {
    let m = new UpdateListingConfigRequest();
    m = Object.assign(m, proto);
    if (proto.listingConfig) {
      m.listingConfig = ListingConfig.fromProto(proto.listingConfig);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.listingConfig !== 'undefined' && this.listingConfig !== null) {
      toReturn['listingConfig'] = 'toApiJson' in this.listingConfig ? this.listingConfig.toApiJson() : this.listingConfig;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateReviewConfigRequest {
  static fromProto(proto) {
    let m = new UpdateReviewConfigRequest();
    m = Object.assign(m, proto);
    if (proto.reviewConfig) {
      m.reviewConfig = ReviewConfig.fromProto(proto.reviewConfig);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.reviewConfig !== 'undefined' && this.reviewConfig !== null) {
      toReturn['reviewConfig'] = 'toApiJson' in this.reviewConfig ? this.reviewConfig.toApiJson() : this.reviewConfig;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateSEOConfigRequest {
  static fromProto(proto) {
    let m = new UpdateSEOConfigRequest();
    m = Object.assign(m, proto);
    if (proto.seoConfig) {
      m.seoConfig = SEOConfig.fromProto(proto.seoConfig);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.seoConfig !== 'undefined' && this.seoConfig !== null) {
      toReturn['seoConfig'] = 'toApiJson' in this.seoConfig ? this.seoConfig.toApiJson() : this.seoConfig;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateSnapshotConfigRequest {
  static fromProto(proto) {
    let m = new UpdateSnapshotConfigRequest();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = GlobalConfig.fromProto(proto.config);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateSnapshotLanguageConfigRequest {
  static fromProto(proto) {
    let m = new UpdateSnapshotLanguageConfigRequest();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = LanguageConfig.fromProto(proto.config);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateSnapshotLiteBusinessDataRequest {
  static fromProto(proto) {
    let m = new UpdateSnapshotLiteBusinessDataRequest();
    m = Object.assign(m, proto);
    if (proto.business) {
      m.business = Business.fromProto(proto.business);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.business !== 'undefined' && this.business !== null) {
      toReturn['business'] = 'toApiJson' in this.business ? this.business.toApiJson() : this.business;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateSocialConfigRequest {
  static fromProto(proto) {
    let m = new UpdateSocialConfigRequest();
    m = Object.assign(m, proto);
    if (proto.socialConfig) {
      m.socialConfig = SocialConfig.fromProto(proto.socialConfig);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.socialConfig !== 'undefined' && this.socialConfig !== null) {
      toReturn['socialConfig'] = 'toApiJson' in this.socialConfig ? this.socialConfig.toApiJson() : this.socialConfig;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateTechnologyConfigRequest {
  static fromProto(proto) {
    let m = new UpdateTechnologyConfigRequest();
    m = Object.assign(m, proto);
    if (proto.technologyConfig) {
      m.technologyConfig = TechnologyConfig.fromProto(proto.technologyConfig);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.technologyConfig !== 'undefined' && this.technologyConfig !== null) {
      toReturn['technologyConfig'] = 'toApiJson' in this.technologyConfig ? this.technologyConfig.toApiJson() : this.technologyConfig;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateTechnologyRequest {
  static fromProto(proto) {
    let m = new UpdateTechnologyRequest();
    m = Object.assign(m, proto);
    if (proto.technology) {
      m.technology = Technology.fromProto(proto.technology);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.technologyId !== 'undefined') {
      toReturn['technologyId'] = this.technologyId;
    }
    if (typeof this.technology !== 'undefined' && this.technology !== null) {
      toReturn['technology'] = 'toApiJson' in this.technology ? this.technology.toApiJson() : this.technology;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateWebsiteConfigRequest {
  static fromProto(proto) {
    let m = new UpdateWebsiteConfigRequest();
    m = Object.assign(m, proto);
    if (proto.websiteConfig) {
      m.websiteConfig = WebsiteConfig.fromProto(proto.websiteConfig);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.websiteConfig !== 'undefined' && this.websiteConfig !== null) {
      toReturn['websiteConfig'] = 'toApiJson' in this.websiteConfig ? this.websiteConfig.toApiJson() : this.websiteConfig;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'snapshot-api.vendasta-local.com',
  'test': '',
  'demo': 'snapshot-api-demo.apigateway.co',
  'prod': 'snapshot-api-prod.apigateway.co',
  'production': 'snapshot-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let AdvertisingSectionApiService = /*#__PURE__*/(() => {
  class AdvertisingSectionApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    get(r) {
      const request = r.toApiJson ? r : new GetSectionRequest(r);
      return this.http.post(this._host + "/snapshot.v1.AdvertisingSectionService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAdvertisingSectionResponse.fromProto(resp)));
    }
    updateConfig(r) {
      const request = r.toApiJson ? r : new UpdateAdvertisingConfigRequest(r);
      return this.http.post(this._host + "/snapshot.v1.AdvertisingSectionService/UpdateConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  AdvertisingSectionApiService.ɵfac = function AdvertisingSectionApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AdvertisingSectionApiService)();
  };
  AdvertisingSectionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AdvertisingSectionApiService,
    factory: AdvertisingSectionApiService.ɵfac,
    providedIn: 'root'
  });
  return AdvertisingSectionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ArtificialIntelligenceApiService = /*#__PURE__*/(() => {
  class ArtificialIntelligenceApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    generateMessage(r) {
      const request = r.toApiJson ? r : new GenerateMessageRequest(r);
      return this.http.post(this._host + "/snapshot.v1.ArtificialIntelligence/GenerateMessage", request.toApiJson(), this.apiOptions()).pipe(map(resp => GenerateMessageResponse.fromProto(resp)));
    }
    contextualize(r) {
      const request = r.toApiJson ? r : new ContextualizeRequest(r);
      return this.http.post(this._host + "/snapshot.v1.ArtificialIntelligence/Contextualize", request.toApiJson(), this.apiOptions()).pipe(map(resp => ContextualizeResponse.fromProto(resp)));
    }
    getWidget(r) {
      const request = r.toApiJson ? r : new GetWidgetRequest(r);
      return this.http.post(this._host + "/snapshot.v1.ArtificialIntelligence/GetWidget", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetWidgetResponse.fromProto(resp)));
    }
  }
  ArtificialIntelligenceApiService.ɵfac = function ArtificialIntelligenceApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ArtificialIntelligenceApiService)();
  };
  ArtificialIntelligenceApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ArtificialIntelligenceApiService,
    factory: ArtificialIntelligenceApiService.ɵfac,
    providedIn: 'root'
  });
  return ArtificialIntelligenceApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CurrentSnapshotApiService = /*#__PURE__*/(() => {
  class CurrentSnapshotApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    updateCurrent(r) {
      const request = r.toApiJson ? r : new UpdateCurrentRequest(r);
      return this.http.post(this._host + "/snapshot.v1.CurrentSnapshot/UpdateCurrent", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getCurrent(r) {
      const request = r.toApiJson ? r : new GetCurrentRequest(r);
      return this.http.post(this._host + "/snapshot.v1.CurrentSnapshot/GetCurrent", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCurrentResponse.fromProto(resp)));
    }
  }
  CurrentSnapshotApiService.ɵfac = function CurrentSnapshotApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CurrentSnapshotApiService)();
  };
  CurrentSnapshotApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CurrentSnapshotApiService,
    factory: CurrentSnapshotApiService.ɵfac,
    providedIn: 'root'
  });
  return CurrentSnapshotApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let EcommerceSectionApiService = /*#__PURE__*/(() => {
  class EcommerceSectionApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    get(r) {
      const request = r.toApiJson ? r : new GetSectionRequest(r);
      return this.http.post(this._host + "/snapshot.v1.EcommerceSectionService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEcommerceSectionResponse.fromProto(resp)));
    }
    updateConfig(r) {
      const request = r.toApiJson ? r : new UpdateEcommerceConfigRequest(r);
      return this.http.post(this._host + "/snapshot.v1.EcommerceSectionService/UpdateConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getSectionAvailability(r) {
      const request = r.toApiJson ? r : new GetSectionAvailabilityRequest(r);
      return this.http.post(this._host + "/snapshot.v1.EcommerceSectionService/GetSectionAvailability", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSectionAvailabilityResponse.fromProto(resp)));
    }
  }
  EcommerceSectionApiService.ɵfac = function EcommerceSectionApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || EcommerceSectionApiService)();
  };
  EcommerceSectionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EcommerceSectionApiService,
    factory: EcommerceSectionApiService.ɵfac,
    providedIn: 'root'
  });
  return EcommerceSectionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ListingSectionApiService = /*#__PURE__*/(() => {
  class ListingSectionApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    get(r) {
      const request = r.toApiJson ? r : new GetSectionRequest(r);
      return this.http.post(this._host + "/snapshot.v1.ListingSectionService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetListingSectionResponse.fromProto(resp)));
    }
    updateConfig(r) {
      const request = r.toApiJson ? r : new UpdateListingConfigRequest(r);
      return this.http.post(this._host + "/snapshot.v1.ListingSectionService/UpdateConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getListingScan(r) {
      const request = r.toApiJson ? r : new GetListingScanRequest(r);
      return this.http.post(this._host + "/snapshot.v1.ListingSectionService/GetListingScan", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetListingScanResponse.fromProto(resp)));
    }
    getAvailableListingSources(r) {
      const request = r.toApiJson ? r : new GetAvailableListingSourcesRequest(r);
      return this.http.post(this._host + "/snapshot.v1.ListingSectionService/GetAvailableListingSources", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAvailableListingSourcesResponse.fromProto(resp)));
    }
    ignoreListingSource(r) {
      const request = r.toApiJson ? r : new IgnoreListingSourceRequest(r);
      return this.http.post(this._host + "/snapshot.v1.ListingSectionService/IgnoreListingSource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unignoreListingSource(r) {
      const request = r.toApiJson ? r : new UnignoreListingSourceRequest(r);
      return this.http.post(this._host + "/snapshot.v1.ListingSectionService/UnignoreListingSource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  ListingSectionApiService.ɵfac = function ListingSectionApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ListingSectionApiService)();
  };
  ListingSectionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ListingSectionApiService,
    factory: ListingSectionApiService.ɵfac,
    providedIn: 'root'
  });
  return ListingSectionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ReviewSectionApiService = /*#__PURE__*/(() => {
  class ReviewSectionApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    get(r) {
      const request = r.toApiJson ? r : new GetSectionRequest(r);
      return this.http.post(this._host + "/snapshot.v1.ReviewSectionService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetReviewSectionResponse.fromProto(resp)));
    }
    updateConfig(r) {
      const request = r.toApiJson ? r : new UpdateReviewConfigRequest(r);
      return this.http.post(this._host + "/snapshot.v1.ReviewSectionService/UpdateConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  ReviewSectionApiService.ɵfac = function ReviewSectionApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ReviewSectionApiService)();
  };
  ReviewSectionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ReviewSectionApiService,
    factory: ReviewSectionApiService.ɵfac,
    providedIn: 'root'
  });
  return ReviewSectionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let SEOSectionApiService = /*#__PURE__*/(() => {
  class SEOSectionApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    get(r) {
      const request = r.toApiJson ? r : new GetSectionRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SEOSectionService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSEOSectionResponse.fromProto(resp)));
    }
    updateConfig(r) {
      const request = r.toApiJson ? r : new UpdateSEOConfigRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SEOSectionService/UpdateConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  SEOSectionApiService.ɵfac = function SEOSectionApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SEOSectionApiService)();
  };
  SEOSectionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SEOSectionApiService,
    factory: SEOSectionApiService.ɵfac,
    providedIn: 'root'
  });
  return SEOSectionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let SnapshotLiteApiService = /*#__PURE__*/(() => {
  class SnapshotLiteApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    get(r) {
      const request = r.toApiJson ? r : new GetSnapshotLiteRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotLiteService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSnapshotLiteResponse.fromProto(resp)));
    }
    updateSnapshotLiteBusinessData(r) {
      const request = r.toApiJson ? r : new UpdateSnapshotLiteBusinessDataRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotLiteService/UpdateSnapshotLiteBusinessData", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  SnapshotLiteApiService.ɵfac = function SnapshotLiteApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SnapshotLiteApiService)();
  };
  SnapshotLiteApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SnapshotLiteApiService,
    factory: SnapshotLiteApiService.ɵfac,
    providedIn: 'root'
  });
  return SnapshotLiteApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let SnapshotRecordApiService = /*#__PURE__*/(() => {
  class SnapshotRecordApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    get(r) {
      const request = r.toApiJson ? r : new GetRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotRecord/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetResponse.fromProto(resp)));
    }
    lookup(r) {
      const request = r.toApiJson ? r : new LookupRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotRecord/Lookup", request.toApiJson(), this.apiOptions()).pipe(map(resp => LookupResponse.fromProto(resp)));
    }
  }
  SnapshotRecordApiService.ɵfac = function SnapshotRecordApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SnapshotRecordApiService)();
  };
  SnapshotRecordApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SnapshotRecordApiService,
    factory: SnapshotRecordApiService.ɵfac,
    providedIn: 'root'
  });
  return SnapshotRecordApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let SnapshotApiService = /*#__PURE__*/(() => {
  class SnapshotApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateSnapshotRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateSnapshotResponse.fromProto(resp)));
    }
    get(r) {
      const request = r.toApiJson ? r : new GetSnapshotRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSnapshotResponse.fromProto(resp)));
    }
    updateConfig(r) {
      const request = r.toApiJson ? r : new UpdateSnapshotConfigRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/UpdateConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateLanguageConfig(r) {
      const request = r.toApiJson ? r : new UpdateSnapshotLanguageConfigRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/UpdateLanguageConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getSnapshotId(r) {
      const request = r.toApiJson ? r : new GetSnapshotIDRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/GetSnapshotID", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSnapshotIDResponse.fromProto(resp)));
    }
    getWhitelabel(r) {
      const request = r.toApiJson ? r : new GetWhitelabelRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/GetWhitelabel", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetWhitelabelResponse.fromProto(resp)));
    }
    getConfiguration(r) {
      const request = r.toApiJson ? r : new GetConfigurationRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/GetConfiguration", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConfigurationResponse.fromProto(resp)));
    }
    getSalesPerson(r) {
      const request = r.toApiJson ? r : new GetSalesPersonRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/GetSalesPerson", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSalesPersonResponse.fromProto(resp)));
    }
    forceRefreshSection(r) {
      const request = r.toApiJson ? r : new ForceRefreshSectionRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/ForceRefreshSection", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getLatestSnapshotId(r) {
      const request = r.toApiJson ? r : new GetLatestSnapshotIDRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/GetLatestSnapshotID", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetLatestSnapshotIDResponse.fromProto(resp)));
    }
    getBusinessIdFromSalesforceId(r) {
      const request = r.toApiJson ? r : new GetBusinessIDFromSalesforceIDRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/GetBusinessIDFromSalesforceID", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBusinessIDFromSalesforceIDResponse.fromProto(resp)));
    }
    getSnapshotCountCreatedBySalespersonId(r) {
      const request = r.toApiJson ? r : new GetSnapshotCountCreatedBySalespersonIDRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/GetSnapshotCountCreatedBySalespersonID", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSnapshotCountCreatedBySalespersonIDResponse.fromProto(resp)));
    }
    previewRefreshSnapshotForBusinesses(r) {
      const request = r.toApiJson ? r : new PreviewRefreshSnapshotForBusinessesRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/PreviewRefreshSnapshotForBusinesses", request.toApiJson(), this.apiOptions()).pipe(map(resp => PreviewRefreshSnapshotForBusinessesResponse.fromProto(resp)));
    }
    shareSnapshot(r) {
      const request = r.toApiJson ? r : new ShareSnapshotRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/ShareSnapshot", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getDomain(r) {
      const request = r.toApiJson ? r : new GetDomainRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/GetDomain", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDomainResponse.fromProto(resp)));
    }
    previewEmail(r) {
      const request = r.toApiJson ? r : new PreviewEmailRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/PreviewEmail", request.toApiJson(), this.apiOptions()).pipe(map(resp => PreviewEmailResponse.fromProto(resp)));
    }
    getDirectCompetitors(r) {
      const request = r.toApiJson ? r : new GetDirectCompetitorsRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/GetDirectCompetitors", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDirectCompetitorsResponse.fromProto(resp)));
    }
    saveDirectCompetitors(r) {
      const request = r.toApiJson ? r : new SaveDirectCompetitorsRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/SaveDirectCompetitors", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    canProvision(r) {
      const request = r.toApiJson ? r : new CanProvisionSnapshotRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/CanProvision", request.toApiJson(), this.apiOptions()).pipe(map(resp => CanProvisionSnapshotResponse.fromProto(resp)));
    }
    provision(r) {
      const request = r.toApiJson ? r : new ProvisionSnapshotRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/Provision", request.toApiJson(), this.apiOptions()).pipe(map(resp => ProvisionSnapshotResponse.fromProto(resp)));
    }
    getSummary(r) {
      const request = r.toApiJson ? r : new GetSummaryRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/GetSummary", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSummaryResponse.fromProto(resp)));
    }
    generatePdf(r) {
      const request = r.toApiJson ? r : new GeneratePDFRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/GeneratePDF", request.toApiJson(), this.apiOptions()).pipe(map(resp => GeneratePDFResponse.fromProto(resp)));
    }
    getFreeSnapshotsRemaining(r) {
      const request = r.toApiJson ? r : new GetFreeSnapshotsRemainingRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SnapshotService/GetFreeSnapshotsRemaining", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetFreeSnapshotsRemainingResponse.fromProto(resp)));
    }
  }
  SnapshotApiService.ɵfac = function SnapshotApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SnapshotApiService)();
  };
  SnapshotApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SnapshotApiService,
    factory: SnapshotApiService.ɵfac,
    providedIn: 'root'
  });
  return SnapshotApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let SocialSectionApiService = /*#__PURE__*/(() => {
  class SocialSectionApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    get(r) {
      const request = r.toApiJson ? r : new GetSectionRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SocialSectionService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSocialSectionResponse.fromProto(resp)));
    }
    updateConfig(r) {
      const request = r.toApiJson ? r : new UpdateSocialConfigRequest(r);
      return this.http.post(this._host + "/snapshot.v1.SocialSectionService/UpdateConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  SocialSectionApiService.ɵfac = function SocialSectionApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SocialSectionApiService)();
  };
  SocialSectionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SocialSectionApiService,
    factory: SocialSectionApiService.ɵfac,
    providedIn: 'root'
  });
  return SocialSectionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let TechnologySectionApiService = /*#__PURE__*/(() => {
  class TechnologySectionApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    get(r) {
      const request = r.toApiJson ? r : new GetSectionRequest(r);
      return this.http.post(this._host + "/snapshot.v1.TechnologySectionService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTechnologySectionResponse.fromProto(resp)));
    }
    updateConfig(r) {
      const request = r.toApiJson ? r : new UpdateTechnologyConfigRequest(r);
      return this.http.post(this._host + "/snapshot.v1.TechnologySectionService/UpdateConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  TechnologySectionApiService.ɵfac = function TechnologySectionApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TechnologySectionApiService)();
  };
  TechnologySectionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TechnologySectionApiService,
    factory: TechnologySectionApiService.ɵfac,
    providedIn: 'root'
  });
  return TechnologySectionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let TechnologyApiService = /*#__PURE__*/(() => {
  class TechnologyApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateTechnologyRequest(r);
      return this.http.post(this._host + "/snapshot.v1.TechnologyService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateTechnologyResponse.fromProto(resp)));
    }
    get(r) {
      const request = r.toApiJson ? r : new GetTechnologyRequest(r);
      return this.http.post(this._host + "/snapshot.v1.TechnologyService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTechnologyResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiTechnologyRequest(r);
      return this.http.post(this._host + "/snapshot.v1.TechnologyService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiTechnologyResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateTechnologyRequest(r);
      return this.http.post(this._host + "/snapshot.v1.TechnologyService/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteTechnologyRequest(r);
      return this.http.post(this._host + "/snapshot.v1.TechnologyService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiCategory(r) {
      const request = r.toApiJson ? r : new GetMultiTechnologyCategoryRequest(r);
      return this.http.post(this._host + "/snapshot.v1.TechnologyService/GetMultiCategory", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiTechnologyCategoryResponse.fromProto(resp)));
    }
  }
  TechnologyApiService.ɵfac = function TechnologyApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TechnologyApiService)();
  };
  TechnologyApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TechnologyApiService,
    factory: TechnologyApiService.ɵfac,
    providedIn: 'root'
  });
  return TechnologyApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let WebsiteSectionApiService = /*#__PURE__*/(() => {
  class WebsiteSectionApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    get(r) {
      const request = r.toApiJson ? r : new GetSectionRequest(r);
      return this.http.post(this._host + "/snapshot.v1.WebsiteSectionService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetWebsiteSectionResponse.fromProto(resp)));
    }
    updateConfig(r) {
      const request = r.toApiJson ? r : new UpdateWebsiteConfigRequest(r);
      return this.http.post(this._host + "/snapshot.v1.WebsiteSectionService/UpdateConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  WebsiteSectionApiService.ɵfac = function WebsiteSectionApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || WebsiteSectionApiService)();
  };
  WebsiteSectionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: WebsiteSectionApiService,
    factory: WebsiteSectionApiService.ɵfac,
    providedIn: 'root'
  });
  return WebsiteSectionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let SnapshotCountSdkService = /*#__PURE__*/(() => {
  class SnapshotCountSdkService {
    constructor(service) {
      this.service = service;
    }
    getSnapshotCount(partnerId, marketId, salespersonId) {
      const req = new GetSnapshotCountCreatedBySalespersonIDRequest({
        partnerId: partnerId,
        marketId: marketId,
        salespersonId: salespersonId
      });
      return this.service.getSnapshotCountCreatedBySalespersonId(req);
    }
  }
  SnapshotCountSdkService.ɵfac = function SnapshotCountSdkService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SnapshotCountSdkService)(i0.ɵɵinject(SnapshotApiService));
  };
  SnapshotCountSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SnapshotCountSdkService,
    factory: SnapshotCountSdkService.ɵfac,
    providedIn: 'root'
  });
  return SnapshotCountSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function buildFieldMask(obj) {
  const fieldMaskPaths = [];
  for (const x in obj) {
    if (obj.hasOwnProperty(x) && obj[x] !== undefined) {
      fieldMaskPaths.push(x);
    }
  }
  return new FieldMask({
    paths: fieldMaskPaths
  });
}
let AdvertisingSectionService = /*#__PURE__*/(() => {
  class AdvertisingSectionService {
    constructor(_api) {
      this._api = _api;
    }
    get(snapshotId) {
      return this._api.get({
        snapshotId: snapshotId
      }).pipe(map(resp => resp.section));
    }
    updateConfig(snapshotId, advertisingConfig) {
      return this._api.updateConfig({
        snapshotId: snapshotId,
        advertisingConfig: new AdvertisingConfig(advertisingConfig),
        fieldMask: buildFieldMask(advertisingConfig)
      });
    }
  }
  AdvertisingSectionService.ɵfac = function AdvertisingSectionService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AdvertisingSectionService)(i0.ɵɵinject(AdvertisingSectionApiService));
  };
  AdvertisingSectionService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AdvertisingSectionService,
    factory: AdvertisingSectionService.ɵfac,
    providedIn: 'root'
  });
  return AdvertisingSectionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CurrentSnapshotService = /*#__PURE__*/(() => {
  class CurrentSnapshotService {
    constructor(_api) {
      this._api = _api;
    }
    get(businessID) {
      const req = new GetCurrentRequest({
        businessId: businessID
      });
      return this._api.getCurrent(req);
    }
  }
  CurrentSnapshotService.ɵfac = function CurrentSnapshotService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CurrentSnapshotService)(i0.ɵɵinject(CurrentSnapshotApiService));
  };
  CurrentSnapshotService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CurrentSnapshotService,
    factory: CurrentSnapshotService.ɵfac,
    providedIn: 'root'
  });
  return CurrentSnapshotService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListingSectionService = /*#__PURE__*/(() => {
  class ListingSectionService {
    constructor(_api) {
      this._api = _api;
    }
    get(snapshotId) {
      return this._api.get({
        snapshotId: snapshotId
      }).pipe(map(resp => resp.section));
    }
    updateConfig(snapshotId, listingConfig) {
      return this._api.updateConfig({
        snapshotId: snapshotId,
        listingConfig: new ListingConfig(listingConfig),
        fieldMask: buildFieldMask(listingConfig)
      });
    }
    getListingScan(businessId) {
      return this._api.getListingScan({
        businessId: businessId
      }).pipe(map(resp => resp.listingScan));
    }
    getAvailableListingSources(snapshotId) {
      return this._api.getAvailableListingSources({
        snapshotId
      }).pipe(map(resp => resp.sources));
    }
    ignoreListingSource(snapshotId, sourceId) {
      return this._api.ignoreListingSource({
        snapshotId,
        sourceId
      }).pipe(map(() => null));
    }
    unignoreListingSource(snapshotId, sourceId) {
      return this._api.unignoreListingSource({
        snapshotId,
        sourceId
      }).pipe(map(() => null));
    }
  }
  ListingSectionService.ɵfac = function ListingSectionService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ListingSectionService)(i0.ɵɵinject(ListingSectionApiService));
  };
  ListingSectionService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ListingSectionService,
    factory: ListingSectionService.ɵfac,
    providedIn: 'root'
  });
  return ListingSectionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ReviewSectionService = /*#__PURE__*/(() => {
  class ReviewSectionService {
    constructor(_api) {
      this._api = _api;
    }
    get(snapshotId) {
      return this._api.get({
        snapshotId: snapshotId
      }).pipe(map(resp => resp.section));
    }
    updateConfig(snapshotId, reviewConfig) {
      return this._api.updateConfig({
        snapshotId: snapshotId,
        reviewConfig: new ReviewConfig(reviewConfig),
        fieldMask: buildFieldMask(reviewConfig)
      });
    }
  }
  ReviewSectionService.ɵfac = function ReviewSectionService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ReviewSectionService)(i0.ɵɵinject(ReviewSectionApiService));
  };
  ReviewSectionService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ReviewSectionService,
    factory: ReviewSectionService.ɵfac,
    providedIn: 'root'
  });
  return ReviewSectionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SEOSectionService = /*#__PURE__*/(() => {
  class SEOSectionService {
    constructor(_api) {
      this._api = _api;
    }
    get(snapshotId) {
      return this._api.get({
        snapshotId: snapshotId
      }).pipe(map(resp => resp.section));
    }
    updateConfig(snapshotId, seoConfig) {
      return this._api.updateConfig({
        snapshotId: snapshotId,
        seoConfig: new SEOConfig(seoConfig),
        fieldMask: buildFieldMask(seoConfig)
      });
    }
  }
  SEOSectionService.ɵfac = function SEOSectionService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SEOSectionService)(i0.ɵɵinject(SEOSectionApiService));
  };
  SEOSectionService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SEOSectionService,
    factory: SEOSectionService.ɵfac,
    providedIn: 'root'
  });
  return SEOSectionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SnapshotLiteService = /*#__PURE__*/(() => {
  class SnapshotLiteService {
    constructor(_api) {
      this._api = _api;
    }
    get(businessId) {
      return this._api.get({
        businessId: businessId
      }).pipe(map(resp => resp.snapshot));
    }
    updateSnapshotLiteBusinessData(businessId, data) {
      return this._api.updateSnapshotLiteBusinessData({
        businessId: businessId,
        business: data,
        fieldMask: buildFieldMask(data)
      });
    }
  }
  SnapshotLiteService.ɵfac = function SnapshotLiteService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SnapshotLiteService)(i0.ɵɵinject(SnapshotLiteApiService));
  };
  SnapshotLiteService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SnapshotLiteService,
    factory: SnapshotLiteService.ɵfac,
    providedIn: 'root'
  });
  return SnapshotLiteService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SocialSectionService = /*#__PURE__*/(() => {
  class SocialSectionService {
    constructor(_api) {
      this._api = _api;
    }
    get(snapshotId) {
      return this._api.get({
        snapshotId: snapshotId
      }).pipe(map(resp => resp.section));
    }
    updateConfig(snapshotId, socialConfig) {
      // need to explicitly convert any object types
      if (socialConfig.selectedFacebookPost !== undefined) {
        socialConfig.selectedFacebookPost = new FacebookPost(socialConfig.selectedFacebookPost);
      }
      return this._api.updateConfig({
        snapshotId: snapshotId,
        socialConfig: new SocialConfig(socialConfig),
        fieldMask: buildFieldMask(socialConfig)
      });
    }
  }
  SocialSectionService.ɵfac = function SocialSectionService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SocialSectionService)(i0.ɵɵinject(SocialSectionApiService));
  };
  SocialSectionService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SocialSectionService,
    factory: SocialSectionService.ɵfac,
    providedIn: 'root'
  });
  return SocialSectionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WebsiteSectionService = /*#__PURE__*/(() => {
  class WebsiteSectionService {
    constructor(_api) {
      this._api = _api;
    }
    get(snapshotId) {
      return this._api.get({
        snapshotId: snapshotId
      }).pipe(map(resp => resp.section));
    }
    updateConfig(snapshotId, websiteConfig) {
      return this._api.updateConfig({
        snapshotId: snapshotId,
        websiteConfig: new WebsiteConfig(websiteConfig),
        fieldMask: buildFieldMask(websiteConfig)
      });
    }
  }
  WebsiteSectionService.ɵfac = function WebsiteSectionService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || WebsiteSectionService)(i0.ɵɵinject(WebsiteSectionApiService));
  };
  WebsiteSectionService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: WebsiteSectionService,
    factory: WebsiteSectionService.ɵfac,
    providedIn: 'root'
  });
  return WebsiteSectionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcommerceSectionService = /*#__PURE__*/(() => {
  class EcommerceSectionService {
    constructor(_api) {
      this._api = _api;
    }
    get(snapshotId) {
      return this._api.get({
        snapshotId: snapshotId
      }).pipe(map(resp => resp.section));
    }
    updateConfig(snapshotId, ecommerceConfig) {
      return this._api.updateConfig({
        snapshotId: snapshotId,
        ecommerceConfig: new EcommerceConfig(ecommerceConfig),
        fieldMask: buildFieldMask(ecommerceConfig)
      });
    }
    getSectionAvailability(snapshotId) {
      return this._api.getSectionAvailability({
        snapshotId: snapshotId
      }).pipe(map(resp => resp.isAvailable));
    }
  }
  EcommerceSectionService.ɵfac = function EcommerceSectionService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || EcommerceSectionService)(i0.ɵɵinject(EcommerceSectionApiService));
  };
  EcommerceSectionService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EcommerceSectionService,
    factory: EcommerceSectionService.ɵfac,
    providedIn: 'root'
  });
  return EcommerceSectionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var Origin = /*#__PURE__*/function (Origin) {
  Origin["UNKNOWN"] = "unknown";
  Origin["PARTNER_CENTER"] = "partner-center";
  Origin["SALES_SUCCESS_CENTER"] = "sales-success-center";
  Origin["ACQUISITION_WIDGET"] = "acquisition-widget";
  Origin["CAMPAIGN"] = "campaign";
  Origin["LIST"] = "list";
  Origin["SNAPSHOT"] = "snapshot";
  Origin["OTHER"] = "other";
  return Origin;
}(Origin || {});
class PagedResponse {
  constructor(results, nextCursor, hasMore) {
    this.results = results;
    this.nextCursor = nextCursor;
    this.hasMore = hasMore;
  }
}
function recordFromApi(recordApi) {
  return {
    snapshotId: recordApi.snapshotId,
    businessId: recordApi.businessId,
    created: recordApi.created,
    expired: recordApi.expired,
    origin: recordApi.origin,
    createdBy: recordApi.createdBy
  };
}
const CORE_WEB_VITALS_SPEED_INDEX = 'speed-index';
const CORE_WEB_VITALS_LARGEST_CONTENTFUL_PAINT = 'largest-contentful-paint';
const CORE_WEB_VITALS_MAX_POTENTIAL_FID = 'max-potential-fid';
const CORE_WEB_VITALS_CUMULATIVE_LAYOUT_SHIFT = 'cumulative-layout-shift';
const CORE_WEB_VITALS_ESTIMATED_INPUT_LATENCY = 'estimated-input-latency'; // deprecated
const CORE_WEB_VITALS_INTERACTIVE = 'interactive'; // not a core web vital
let SnapshotRecordService = /*#__PURE__*/(() => {
  class SnapshotRecordService {
    constructor(_api) {
      this._api = _api;
    }
    get(businessId, snapshotId) {
      return this._api.get({
        businessId: businessId,
        snapshotId: snapshotId
      }).pipe(map(resp => resp.record));
    }
    lookup(businessId, cursor, pageSize) {
      return this._api.lookup({
        businessId: businessId,
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      }).pipe(map(resp => {
        const records = (resp.record || []).map(r => recordFromApi(r));
        return new PagedResponse(records, resp.pagingMetadata.nextCursor, resp.pagingMetadata.hasMore);
      }));
    }
    getLatestSnapshot(businessId) {
      return this._api.lookup({
        businessId: businessId,
        pagingOptions: {
          cursor: '',
          pageSize: 1
        }
      }).pipe(map(resp => (resp.record || []).map(r => recordFromApi(r))));
    }
  }
  SnapshotRecordService.ɵfac = function SnapshotRecordService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SnapshotRecordService)(i0.ɵɵinject(SnapshotRecordApiService));
  };
  SnapshotRecordService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SnapshotRecordService,
    factory: SnapshotRecordService.ɵfac,
    providedIn: 'root'
  });
  return SnapshotRecordService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SnapshotService = /*#__PURE__*/(() => {
  class SnapshotService {
    constructor(_api) {
      this._api = _api;
    }
    get(snapshotId) {
      return this._api.get({
        snapshotId: snapshotId
      }).pipe(map(resp => resp.snapshot));
    }
    provision(businessId, origin, originDetails, inferMissingData) {
      let source = '';
      if (!!origin) {
        source += origin;
        if (!!originDetails) {
          for (const detail of originDetails) {
            source += `:${detail}`;
          }
        }
      }
      return this._api.provision({
        businessId: businessId,
        origin: source,
        options: {
          inferMissingData: inferMissingData
        }
      }).pipe(map(resp => resp.snapshotId));
    }
    getSummary(snapshotId) {
      return this._api.getSummary({
        snapshotId: snapshotId
      });
    }
    getLatestSnapshotId(businessId) {
      return this._api.getLatestSnapshotId({
        businessId: businessId
      }).pipe(map(resp => resp.snapshotId));
    }
    updateConfig(snapshotId, snapshotConfig) {
      // prevent saving an empty config in the Snapshot model
      const fieldMask = buildFieldMask(snapshotConfig);
      if (fieldMask.paths.length === 0) {
        throw new Error('No fields to update');
      }
      return this._api.updateConfig({
        snapshotId: snapshotId,
        config: new GlobalConfig(snapshotConfig),
        fieldMask: fieldMask
      });
    }
    updateLanguageConfig(snapshotId, languageConfig) {
      return this._api.updateLanguageConfig({
        snapshotId: snapshotId,
        config: new LanguageConfig(languageConfig),
        fieldMask: buildFieldMask(languageConfig)
      });
    }
    getWhitelabel(snapshotId) {
      return this._api.getWhitelabel({
        snapshotId: snapshotId
      }).pipe(map(resp => resp.branding));
    }
    getSalesPerson(snapshotId) {
      return this._api.getSalesPerson({
        snapshotId: snapshotId
      }).pipe(map(resp => resp.salesPerson));
    }
    getConfiguration(snapshotId) {
      return this._api.getConfiguration({
        snapshotId: snapshotId
      }).pipe(map(resp => resp.configuration));
    }
    getBusinessIdFromSalesforceId(salesforceId, partnerId) {
      return this._api.getBusinessIdFromSalesforceId({
        salesforceId: salesforceId,
        partnerId: partnerId
      }).pipe(map(resp => resp.businessId));
    }
    shareSnapshot(businessId, sender, contacts, snapshotId, email, domain) {
      return this._api.shareSnapshot({
        businessId: businessId,
        sender: sender,
        contacts: contacts,
        snapshotId: snapshotId,
        email: email,
        domain: domain
      });
    }
    previewEmail(email) {
      return this._api.previewEmail({
        email: email
      }).pipe(map(resp => {
        return this.stringToBlob(resp.renderedTemplate, 'application/html');
      }));
    }
    stringToBlob(value, type) {
      const binary = atob(value);
      const binaryLen = binary.length;
      const bytes = new Uint8Array(binaryLen);
      for (let i = 0; i < binaryLen; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      return new Blob([bytes], {
        type: type
      });
    }
    getDomain(partnerId, application) {
      return this._api.getDomain({
        partnerId: partnerId,
        application: application
      }).pipe(map(res => res.primary));
    }
    getDirectCompetitors(snapshotId) {
      return this._api.getDirectCompetitors({
        snapshotId: snapshotId
      }).pipe(map(res => res.directCompetitors));
    }
    saveDirectCompetitors(snapshotId, directCompetitors) {
      return this._api.saveDirectCompetitors({
        snapshotId: snapshotId,
        directCompetitors: directCompetitors
      });
    }
    generatePdf(snapshotId) {
      return this._api.generatePdf({
        snapshotId
      }).pipe(map(res => res?.pdf));
    }
    canProvision(namespace, businessId, userId) {
      return this._api.canProvision({
        namespace,
        businessId,
        userId
      }).pipe(map(res => ({
        canProvision: res.canProvision,
        reason: res.reason?.length > 0 ? res.reason : undefined
      })));
    }
  }
  SnapshotService.ɵfac = function SnapshotService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SnapshotService)(i0.ɵɵinject(SnapshotApiService));
  };
  SnapshotService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SnapshotService,
    factory: SnapshotService.ɵfac,
    providedIn: 'root'
  });
  return SnapshotService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TechnologySectionService = /*#__PURE__*/(() => {
  class TechnologySectionService {
    constructor(_api) {
      this._api = _api;
    }
    get(snapshotId) {
      return this._api.get({
        snapshotId: snapshotId
      }).pipe(map(resp => resp.section));
    }
    updateConfig(snapshotId, technologyConfig) {
      return this._api.updateConfig({
        snapshotId,
        technologyConfig: new TechnologyConfig(technologyConfig),
        fieldMask: buildFieldMask(technologyConfig)
      });
    }
  }
  TechnologySectionService.ɵfac = function TechnologySectionService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TechnologySectionService)(i0.ɵɵinject(TechnologySectionApiService));
  };
  TechnologySectionService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TechnologySectionService,
    factory: TechnologySectionService.ɵfac,
    providedIn: 'root'
  });
  return TechnologySectionService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SnapshotAIService = /*#__PURE__*/(() => {
  class SnapshotAIService {
    constructor(_api) {
      this._api = _api;
    }
    getWidget(snapshotId) {
      return this._api.getWidget({
        snapshotId: snapshotId
      });
    }
  }
  SnapshotAIService.ɵfac = function SnapshotAIService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SnapshotAIService)(i0.ɵɵinject(ArtificialIntelligenceApiService));
  };
  SnapshotAIService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SnapshotAIService,
    factory: SnapshotAIService.ɵfac,
    providedIn: "root"
  });
  return SnapshotAIService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AIPrompt, Access, AdvertisingConfig, AdvertisingData, AdvertisingSection, AdvertisingSectionApiService, AdvertisingSectionService, AdwordsData, AppDomain, Application, ArtificialIntelligenceApiService, Audit, AuditDetail, AuditSummary, AvailableListingSource, Branding, BrandingAssets, Business, CORE_WEB_VITALS_CUMULATIVE_LAYOUT_SHIFT, CORE_WEB_VITALS_ESTIMATED_INPUT_LATENCY, CORE_WEB_VITALS_INTERACTIVE, CORE_WEB_VITALS_LARGEST_CONTENTFUL_PAINT, CORE_WEB_VITALS_MAX_POTENTIAL_FID, CORE_WEB_VITALS_SPEED_INDEX, CanProvisionSnapshotRequest, CanProvisionSnapshotResponse, CannotProvisionReason, Clicks, CompetitionAnalysis, Competitor, CompetitorHomepageData, Configuration, Contact, ContextualizeRequest, ContextualizeResponse, CreateSnapshotRequest, CreateSnapshotResponse, CreateTechnologyRequest, CreateTechnologyResponse, Current, CurrentSnapshotApiService, CurrentSnapshotService, DataProviderAccuracy, DataProviderAccuracyStatus, DataProviderAccuracyStatusV2, DeleteTechnologyRequest, DirectCompetitor, Domain, DomainMetrics, EcommerceConfig, EcommerceData, EcommerceDataApplicationsAvailabilityEntry, EcommerceDataCompetitor, EcommerceSection, EcommerceSectionApiService, EcommerceSectionService, Email, FacebookData, FacebookPost, FieldMask, FloatRange, ForceRefreshSectionRequest, GMBClaimStatus, GenerateMessageRequest, GenerateMessageResponse, GeneratePDFRequest, GeneratePDFResponse, GetAdvertisingSectionResponse, GetAvailableListingSourcesRequest, GetAvailableListingSourcesResponse, GetBusinessIDFromSalesforceIDRequest, GetBusinessIDFromSalesforceIDResponse, GetConfigurationRequest, GetConfigurationResponse, GetCurrentRequest, GetCurrentResponse, GetDirectCompetitorsRequest, GetDirectCompetitorsResponse, GetDomainRequest, GetDomainResponse, GetEcommerceSectionResponse, GetFreeSnapshotsRemainingRequest, GetFreeSnapshotsRemainingResponse, GetLatestSnapshotIDRequest, GetLatestSnapshotIDResponse, GetListingScanRequest, GetListingScanResponse, GetListingSectionResponse, GetMultiTechnologyCategoryRequest, GetMultiTechnologyCategoryResponse, GetMultiTechnologyRequest, GetMultiTechnologyResponse, GetRequest, GetResponse, GetReviewSectionResponse, GetSEOSectionResponse, GetSalesPersonRequest, GetSalesPersonResponse, GetSectionAvailabilityRequest, GetSectionAvailabilityResponse, GetSectionRequest, GetSnapshotCountCreatedBySalespersonIDRequest, GetSnapshotCountCreatedBySalespersonIDResponse, GetSnapshotIDRequest, GetSnapshotIDResponse, GetSnapshotLiteRequest, GetSnapshotLiteResponse, GetSnapshotRequest, GetSnapshotResponse, GetSocialSectionResponse, GetSummaryRequest, GetSummaryResponse, GetTechnologyRequest, GetTechnologyResponse, GetTechnologySectionResponse, GetWebsiteSectionResponse, GetWhitelabelRequest, GetWhitelabelResponse, GetWidgetRequest, GetWidgetResponse, GlobalConfig, GlobalConfigEnabledSection, Grade, HomepageData, IgnoreListingSourceRequest, Impressions, InaccurateData, IndustryPercentiles, InferredFields, InstagramData, InstagramDataInstagramDataStatus, IntRange, Keyword, KeywordMetrics, LanguageConfig, LatLng, Listing, ListingAccuracy, ListingAccuracyCompetitor, ListingConfig, ListingData, ListingListingStatus, ListingPresence, ListingPresenceCompetitor, ListingScan, ListingSection, ListingSectionApiService, ListingSectionService, ListingSource, ListingV2, ListingV2ListingField, ListingV2ListingStatus, ListingV2Source, Listings, LocalSEOData, Location, LookupRequest, LookupResponse, MCPOptions, OrganicDomainData, OrganicKeywordData, Origin, PagedRequestOptions, PagedResponse, PagedResponseMetadata, PayPerClickData, PreviewEmailRequest, PreviewEmailResponse, PreviewRefreshSnapshotForBusinessesRequest, PreviewRefreshSnapshotForBusinessesResponse, ProvisionSnapshotOptions, ProvisionSnapshotRequest, ProvisionSnapshotResponse, Record, Results, ResultsReviews, ReviewConfig, ReviewData, ReviewDataCompetitor, ReviewDataItem, ReviewSection, ReviewSectionApiService, ReviewSectionService, Role, Rule, RuleDetail, RuleSummary, SEOConfig, SEOData, SEODomainMetrics, SEOSection, SEOSectionApiService, SEOSectionService, SERPMetrics, SSLSummary, SSLSummaryStatus, SalesPerson, SampleSourceCount, SaveDirectCompetitorsRequest, Section, SectionContent, SectionSummary, ShareSnapshotRequest, Snapshot, SnapshotAIService, SnapshotApiService, SnapshotCountSdkService, SnapshotData, SnapshotLite, SnapshotLiteApiService, SnapshotLiteService, SnapshotRecordApiService, SnapshotRecordService, SnapshotService, SocialConfig, SocialData, SocialDataCompetitor, SocialDataCompetitorFacebookData, SocialDataCompetitorInstagramData, SocialDataCompetitorTwitterData, SocialDataItem, SocialSection, SocialSectionApiService, SocialSectionService, Status, Technology, TechnologyApiService, TechnologyCategory, TechnologyConfig, TechnologyData, TechnologySection, TechnologySectionApiService, TechnologySectionService, TwitterData, URL, UnignoreListingSourceRequest, UpdateAdvertisingConfigRequest, UpdateCurrentRequest, UpdateEcommerceConfigRequest, UpdateListingConfigRequest, UpdateReviewConfigRequest, UpdateSEOConfigRequest, UpdateSnapshotConfigRequest, UpdateSnapshotLanguageConfigRequest, UpdateSnapshotLiteBusinessDataRequest, UpdateSocialConfigRequest, UpdateTechnologyConfigRequest, UpdateTechnologyRequest, UpdateWebsiteConfigRequest, Vicinity, VideoStyle, WebsiteConfig, WebsiteData, WebsiteDataCompetitor, WebsiteSection, WebsiteSectionApiService, WebsiteSectionService };
